// MATCHES
// Support für IE 9+, Edge und Android bis Version 4.4.4
// -------------------------------------------------------------------------------------------------

(function() {
    if (!Element.prototype.matches) {
        var matches = function(selector) {
          return (this.matchesSelector || this.msMatchesSelector || this.webkitMatchesSelector).call(this, selector);
        };

        Element.prototype.matches = matches;
    }
})();


// SVG4EVERYBODY
// SVG-Support für alle IE-Versionen
// -------------------------------------------------------------------------------------------------

(function(document, window) {
    /* jshint nocomma: false */

    function embed(svg, g) {
        if (g) {
            var viewBox  = !svg.getAttribute('viewBox') && g.getAttribute('viewBox'),
                fragment = document.createDocumentFragment(), clone = g.cloneNode(!0);

            for (viewBox && svg.setAttribute('viewBox', viewBox); clone.childNodes.length;) {
                fragment.appendChild(clone.firstChild);
            }

            svg.appendChild(fragment);
        }
    }

    function loadreadystatechange(xhr) {
        xhr.onreadystatechange = function() {
            if (xhr.readyState === 4) {
                var x = document.createElement('x');

                x.innerHTML = xhr.responseText, xhr.s.splice(0).map(function(array) {
                    embed(array[0], x.querySelector('#' + array[1].replace(/(\W)/g, '\\$1')));
                });
            }
        }, xhr.onreadystatechange();
    }

    function svg4everybody() {
        var $uses                 = document.getElementsByTagName('use'),
            polyfill              = /\bFirefox\b|\bEdge\b|\bTrident\/[567]\b|\bVersion\/7.0 Safari\b/.test(navigator.userAgent) || (navigator.userAgent.match(/AppleWebKit\/(\d+)/) || [])[1] < 537,
            requestAnimationFrame = window.requestAnimationFrame || setTimeout,
            $svgCache             = {};

        function oninterval() {
            for (var use, svg, i = 0; i < $uses.length;) {
                if (use = $uses[i], svg = use.parentNode, svg && /svg/i.test(svg.nodeName)) {
                    var src      = use.getAttribute('xlink:href'),
                        $url     = src.split('#'),
                        url_root = $url[0],
                        url_hash = $url[1];

                    if (svg.removeChild(use), url_root.length) {
                        var xhr = $svgCache[url_root] = $svgCache[url_root] || new XMLHttpRequest();
                        xhr.s || (xhr.s = [], xhr.open('GET', url_root), xhr.send()), xhr.s.push([ svg, url_hash ]),
                        loadreadystatechange(xhr);
                    }
                    else {
                        embed(svg, document.getElementById(url_hash));
                    }
                } else {
                    i += 1;
                }
            }
            requestAnimationFrame(oninterval, 17);
        }

        if (polyfill) {
            oninterval();
        }
    }

    svg4everybody();
}(document, window));

// HELPERS
// -------------------------------------------------------------------------------------------------

(function(document, window) {
    var $helpers,
        $$;

    // Interne Funktion

    function _is_document($node) {
        return $node !== null && $node.nodeType === $node.DOCUMENT_NODE;
    }

    function _is_window($node) {
        return $node !== null && $node === window;
    }

    function _is_array($obj) {
        return Object.prototype.toString.call($obj) === '[object Array]';
    }

    function _is_input($node) {
        return $node.tagName === 'INPUT' ||
               $node.tagName === 'SELECT' ||
               $node.tagName === 'TEXTAREA';
    }

    function _query(selector, context) {
        var simpleRe = /^(#?[\w-]+|\.[\w-.]+)$/,
            periodRe = /\./g,
            slice    = [].slice,
            $nodes;

        if (simpleRe.test(selector)) {
            switch(selector[0]) {
                case '#':
                    $nodes = context.getElementById(selector.substr(1));
                    break;
                case '.':
                    $nodes = slice.call(context.getElementsByClassName(selector.substr(1).replace(periodRe, ' ')));
                    break;
                default:
                    $nodes = slice.call(context.getElementsByTagName(selector));
            }
        }
        else {
            $nodes = slice.call(context.querySelectorAll(selector));
        }

        return $nodes ? (_is_array($nodes) ? $nodes : [$nodes]) : [];
    }

    function _get_filtered_nodes($nodes, selector) {
        var $filtered_nodes = [];

        for (var i = 0, len = $nodes.length; $nodes !== null && (i < len); i++) {
            if ($nodes[i].nodeType === 1) {
                if (typeof selector === 'undefined') {
                    $filtered_nodes.push($nodes[i]);
                }
                else if($nodes[i].tagName.toLowerCase() === selector) {
                    $filtered_nodes.push($nodes[i]);
                }
            }
        }

        return $filtered_nodes;
    }

    function _create_element(html) {
        var $div = document.createElement('div');

        $div.innerHTML = html.trim(); // textContent/nodeValue funktionieren hier nicht,
                                      // Bug bei Popups: http://stackoverflow.com/a/25896886

        return _get_filtered_nodes($div.childNodes);
    }

    function _get_scroll_offset($node) {
        var top,
            left;

        if (_is_window($node)) {
            if (window.pageXOffset !== null) {
                top  = window.pageYOffset;
                left = window.pageXOffset;
            }
        }
        else {
            top  = $node.scrollTop;
            left = $node.scrollLeft;
        }

        return {
            top  : top,
            left : left
        };
    }

    function _get_vendor_property(property) {
        var css_prefixes = ['Moz', 'ms', 'Webkit'],
            $div         = document.createElement('div');

        if (property in $div) {
            return property;
        }

        var cap_name  = property.charAt(0).toUpperCase() + property.slice(1),
            orig_name = property;

        for (var i = css_prefixes.length; i > 0; i--) {
            property = css_prefixes[i] + cap_name;

            if (property in $div.style) {
                return property;
            }
        }

        return orig_name;
    }

    function _camel_case_property(property) {
        return property.replace(/-([\da-z])/gi, function(all, letter) {
            return letter.toUpperCase();
        });
    }

    function _get_prefixed_event(type, $types) {
        var $div      = document.createElement('div').style,
            $prefixes = ['', 'Moz', 'ms', 'Webkit'],
            prefix;

        for (var i = 0, len = $prefixes.length; i < len; i++) {
            prefix = $prefixes[i] + type.charAt(0).toUpperCase() + type.substr(1, type.length - 4);

            if (prefix in $div) {
                return $types[prefix];
            }
        }

        return type;
    }

    function _get_event_type_wheel(type) {
        return type === 'wheel' ? 'onwheel' in document || document.documentMode >= 9 ? 'wheel' : 'mousewheel' : type;
    }

    function _get_event_type_animatedend(type) {
        return _get_prefixed_event(type, {
            'animation'       : 'animationend',
            'MozAnimation'    : 'animationend',
            'WebkitAnimation' : 'webkitAnimationEnd',
            'msAnimation'     : 'MSAnimationEnd'
        });
    }

    function _get_event_type_transitionend(type) {
        return _get_prefixed_event(type, {
            'transition'       : 'transitionend',
            'MozTransition'    : 'transitionend',
            'WebkitTransition' : 'webkitTransitionEnd',
            'msTransition'     : 'MSTransitionEnd'
        });
    }

    function _get_event_type(type) {
        type = _get_event_type_animatedend(type) || _get_event_type_transitionend(type);
        type = _get_event_type_wheel(type);

        return type;
    }

    // Erstellt Helpers Object

    $$ = function(selector, context) {
        context = context || document;
        return new $helpers(selector, context);
    };

    $helpers = function(selector, context) {
        var _this  = this,
            $nodes = [];

        if (selector) {
            if (typeof selector === 'string') {
                selector = selector.trim();

                if (/<[a-z][\s\S]*>/i.test(selector)) {
                    $nodes = _create_element(selector);
                }
                else {
                    $nodes = _query(selector, context);
                }
            }
            else if (_is_array(selector)) {
                $nodes = selector;
            }
            else {
                $nodes = [selector];
            }
        }

        for (var i = 0, len = $nodes.length; i < len; i++) {
            _this[i] = $nodes[i];
        }

        _this.length = $nodes.length;

        return _this;
    };

    // Helpers API

    $helpers.prototype = {
        is_helper: true,

        find: function(selector) {
            var $this  = this,
                $nodes = [],
                context;

            if ($this.length !== 0) {
                if ($this.length === 1) {
                    $nodes = _query(selector, $this[0]);
                }
                else {
                    for (var i = 0, len = $this.length; i < len; i++) {
                        $nodes = $nodes.concat(
                            _query(selector, $this[i])
                        );
                    }

                    $nodes = $nodes.reduce(function(a, b) {
                        if (a.indexOf(b) < 0) {
                            a.push(b);
                        }

                        return a;
                    }, []);
                }
            }

            return $$($nodes, context);
        },

        children: function(selector) {
            var $this                 = this,
                $filtered_child_nodes = [],
                $child_node;

            for (var i = 0, len = $this.length; i < len; i++) {
                $child_node = this[i].firstChild;

                while ($child_node) {
                    if ($child_node.nodeType === 1 && $child_node.matches(selector)) {
                        $filtered_child_nodes.push($child_node);
                    }

                    $child_node = $child_node.nextSibling;
                }
            }

            return $$($filtered_child_nodes);
        },

        get_parent: function(selector) {
            var $this = this,
                maybe_class,
                name_only,
                tag_name,
                class_name,
                $obj;

            if ($this.length === 1) {
                $obj = $this[0];

                if (typeof selector !== 'undefined') {
                    maybe_class = selector[0] === '.';
                    name_only   = maybe_class ? selector.slice(1) : selector;
                    tag_name    = name_only.toUpperCase();
                }

                do {
                    $obj       = $obj.parentNode;
                    class_name = (' ' + $obj.className + ' ').replace(/[\t\r\n\f]/g, ' ');

                    if ((typeof selector === 'undefined' && $obj.nodeType === 1) ||
                        (maybe_class && class_name.indexOf(' ' + name_only + ' ') > -1) ||
                        $obj.tagName === tag_name) {

                        return $$($obj);
                    }
                }
                while ($obj && $obj.nodeType !== 9);
            }
        },

        append: function($obj) {
            var $this = this;

            if (typeof $obj === 'string') {
                $obj = _create_element($obj);
            }

            for (var i = 0, len = $this.length; i < len; i++) {
                for (var j = 0, obj_len = $obj.length; j < obj_len; j++) {
                    $this[i].appendChild($obj[j]);
                }
            }
        },

        prepend: function($obj) {
            var $this = this;

            if (typeof $obj === 'string') {
                $obj = _create_element($obj);
            }

            for (var i = 0, len = $this.length; i < len; i++) {
                for (var j = 0, obj_len = $obj.length; j < obj_len; j++) {
                    $this[i].insertBefore($obj[j], $this[i].childNodes[0]);
                }
            }
        },

        before: function($obj) {
            var $this = this;

            if (typeof $obj === 'string') {
                $obj = _create_element($obj);
            }

            for (var i = 0, len = $this.length; i < len; i++) {
                for (var j = 0, obj_len = $obj.length; j < obj_len; j++) {
                    $this[i].parentNode.insertBefore($obj[j], $this[i]);
                }
            }
        },

        after: function($obj) {
            var $this = this;

            if (typeof $obj === 'string') {
                $obj = _create_element($obj);
            }

            for (var i = 0, len = $this.length; i < len; i++) {
                for (var j = 0, obj_len = $obj.length; j < obj_len; j++) {
                    $this[i].parentNode.insertBefore($obj[j], $this[i].nextSibling);
                }
            }
        },

        remove: function() {
            var $this = this;

            for (var i = 0, len = $this.length; i < len; i++) {
                $this[i].parentNode.removeChild($this[i]);
            }
        },

        remove_children: function() {
            var $this = this;

            for (var i = 0, len = $this.length; i < len; i++) {
                while ($this[i].firstChild) {
                    $this[i].removeChild($this[i].firstChild);
                }
            }
        },

        empty: function() {
            var $this = this;

            for (var i = 0, len = $this.length; i < len; i++) {
                while ($this[i].firstChild) {
                    $this[i].removeChild($this[i].firstChild);
                }
            }
        },

        clone: function() {
            var $this  = this;

            if ($this.length === 1) {
                return $$($this[0].cloneNode(true));
            }
        },

        next_sibling: function() {
            var $this = this;

            if ($this.length === 1) {
                var $obj = $this[0];

                do {
                    $obj = $obj.nextSibling;
                }
                while ($obj && $obj.nodeType !== 1);

                return $$($obj);
            }
        },

        prev_sibling: function() {
            var $this = this;

            if ($this.length === 1) {
                var $obj = $this[0];

                do {
                    $obj = $obj.previousSibling;
                }
                while ($obj && $obj.nodeType !== 1);

                return $$($obj);
            }
        },

        get_siblings: function() {
            var $this     = this,
                $siblings = [];

            if ($this.length === 1) {
                var $obj      = $this[0],
                    $children = $obj.parentNode.children;

                for (var i = 0, len = $children.length; i < len; i++) {
                    if ($children[i].nodeType === 1 && $children[i] !== $obj) {
                        $siblings.push($children[i]);
                    }
                }
            }

            return $$($siblings);
        },

        get_attribute: function(attribute) {
            var $this = this,
                value = null;

            if ($this.length === 1) {
                if (_is_input($this[0]) && attribute === 'value') {
                    value = $this[0][attribute];
                }
                else {
                    value = $this[0].getAttribute(attribute);
                }
            }

            return value === null ? '' : value;
        },

        set_attribute: function(attribute, value) {
            var $this = this;

            for (var i = 0, len = $this.length; i < len; i++) {
                if (_is_input($this[i]) && attribute === 'value') {
                    $this[i][attribute] = value;
                }
                else if (value) {
                    $this[i].setAttribute(attribute, value);
                }
                else {
                    $this[i].removeAttribute(attribute);
                }
            }
        },

        set_text: function(text) {
            var $this = this;

            if ($this.length === 1) {
                $this[0].textContent = text.toString().trim();
            }
        },

        get_text: function() {
            var $this = this,
                text  = '';

            if ($this.length === 1) {
                text = $this[0].textContent.trim();
            }

            return text;
        },

        insert_html: function(html, outer) {
            var $this = this;

            if ($this.length === 1) {
                if (outer === true) {
                    $this[0].outerHTML = html;
                }
                else {
                    $this[0].innerHTML = html;
                }
            }
        },

        get_html: function(outer) {
            var $this = this,
                html  = '';

            if ($this.length === 1) {
                if (outer === true) {
                    html = $this[0].outerHTML;
                }
                else {
                    html = $this[0].innerHTML;
                }
            }

            return html.trim();
        },

        get_file: function() {
            var $this    = this,
                filename = '',
                filetype = '',
                filesize = 0,
                $file;

            if ($this.length === 1) {
                $file = $this[0].files;

                if ($file.length) {
                    filename = $file[0].name;
                    filesize = $file[0].size;
                    filetype = $file[0].type;
                }
            }

            return {
                'filename' : filename,
                'filesize' : filesize,
                'filetype' : filetype
            };
        },

        is_tag: function(tagname) {
            var $this  = this,
                is_tag = false;

            if ($this.length === 1) {
                is_tag = $this[0].tagName.toLowerCase() === tagname;
            }

            return is_tag;
        },

        is_visible: function() {
            var $this      = this,
                is_visible = false,
                $styles,
                $obj;

            if ($this.length === 1) {
                $obj       = $this[0];
                is_visible = true;

                while ($obj && $obj.nodeType !== 9) {
                    $styles = window.getComputedStyle($obj, null);

                    if ($obj.offsetWidth === 0 &&
                        $obj.offsetHeight === 0 &&
                        $styles.display === 'none') {

                        is_visible = false;
                        break;
                    }

                    $obj = $obj.parentElement;
                }
            }

            return is_visible;
        },

        index: function(element) {
            var $this = this;

            if (typeof element === 'object') {
                for (var i = 0, len = $this.length; i < len; i++) {
                    if ($this[i] === element) {
                        return i;
                    }
                }
            }
            else if (typeof element === 'number') {
                if (element === -1) {
                    element = $this.length - 1;
                }

                return $$($this[element]);
            }
        },

        for_each: function(callback) {
            var $this = this;

            for (var i = 0, len = $this.length; i < len; i++) {
                callback.call($this[i], i);
            }
        },

        is_checked: function() {
            var $this      = this,
                is_checked = false;

            if ($this.length === 1) {
                is_checked = $this[0].checked;
            }

            return is_checked;
        },

        add_class: function(selector) {
            var $this     = this,
                $selector = selector.split(' '),
                updated   = false,
                trimmed_classes,
                classes;

            for (var i = 0, len = $this.length; i < len; i++) {
                trimmed_classes = String.prototype.trim.call($this[i].getAttribute('class') || '');
                classes         = trimmed_classes ? trimmed_classes.split(/\s+/) : [];

                for (var j = 0, selector_len = $selector.length; j < selector_len; j++) {
                    if (classes.indexOf($selector[j]) === -1) {
                        classes.push($selector[j]);
                        updated = true;
                    }
                }

                if (updated) {
                    $this[i].setAttribute('class', classes.sort().join(' '));
                    updated = false;
                }
            }
        },

        remove_class: function(selector) {
            var $this     = this,
                $selector = selector.split(' '),
                updated   = false,
                trimmed_classes,
                classes,
                index;

            for (var i = 0, len = $this.length; i < len; i++) {
                trimmed_classes = String.prototype.trim.call($this[i].getAttribute('class') || '');
                classes         = trimmed_classes ? trimmed_classes.split(/\s+/) : [];

                for (var j = 0, selector_len = $selector.length; j < selector_len; j++) {
                    index = classes.indexOf($selector[j]);

                    if (index > -1) {
                        classes.splice(index, 1);
                        updated = true;
                    }
                }

                if (updated) {
                    if (classes.length) {
                        $this[i].setAttribute('class', classes.sort().join(' '));
                    }
                    else {
                        $this[i].removeAttribute('class');
                    }
                    updated = false;
                }
            }
        },

        has_class: function(selector) {
            var $this     = this,
                has_class = false;

            if ($this.length === 1) {
                has_class = $this[0].classList.contains(selector);
            }

            return has_class;
        },

        focus: function() {
            var $this = this;

            if ($this.length) {
                $this[0].focus();
            }
        },

        click: function() {
            var $this = this;

            if ($this.length) {
                $this[0].click();
            }
        },

        set_style: function($styles) {
            var $this = this,
                property_camel_case,
                property_vendor;

            for (var i = 0, len = $this.length; i < len; i++) {
                for (var property in $styles) {
                    if ($styles.hasOwnProperty(property)) {
                        property_camel_case = _camel_case_property(property);
                        property_vendor     = _get_vendor_property(property_camel_case);

                        $this[i].style[property_vendor] = $styles[property];
                    }
                }
            }
        },

        get_style: function(property) {
            var $this = this,
                style = '',
                $styles;

            if ($this.length === 1) {
                $styles = window.getComputedStyle($this[0], null);
                style   = $styles.getPropertyValue(property);
            }

            return style;
        },

        set_data: function(key, value) {
            var $this = this;

            if ($this.length === 1) {
                $this[0][key] = value;
            }
        },

        get_data: function(key) {
            var $this = this;

            if ($this.length === 1) {
                return $this[0][key];
            }
        },

        get_width: function() {
            var $this = this,
                width = 0;

            if ($this.length === 1) {
                if (_is_window($this[0])) {
                    width = document.documentElement.clientWidth;
                }
                else if (_is_document($this[0])) {
                    width = Math.max(
                        document.body.scrollWidth,
                        document.body.offsetWidth
                    );
                }
                else {
                    width = this[0].offsetWidth;
                }
            }

            return width;
        },

        get_height: function() {
            var $this  = this,
                height = 0;

            if ($this.length === 1) {
                if (_is_window($this[0])) {
                    height = document.documentElement.clientHeight;
                }
                else if (_is_document($this[0])) {
                    height = Math.max(
                        document.body.scrollHeight,
                        document.body.offsetHeight
                    );
                }
                else {
                    height = this[0].offsetHeight;
                }
            }

            return height;
        },

        get_offset_top: function() {
            var $this = this,
                top   = 0,
                $obj;

            if ($this.length === 1) {
                $obj = $this[0];
                top   = $obj.offsetTop;

                while ($obj = $obj.offsetParent) {
                    top += $obj.offsetTop;
                }
            }

            return top;
        },

        get_offset_left: function() {
            var $this = this,
                left  = 0,
                $obj;

            if ($this.length === 1) {
                $obj = $this[0];
                left = $obj.offsetLeft;

                while ($obj = $obj.offsetParent) {
                    left += $obj.offsetLeft;
                }
            }

            return left;
        },

        get_scroll_top: function() {
            var $this      = this,
                scroll_top = 0;

            if ($this.length === 1) {
                scroll_top = _get_scroll_offset($this[0]).top;
            }

            return scroll_top;
        },

        get_scroll_left: function() {
            var $this       = this,
                scroll_left = 0;

            if ($this.length === 1) {
                scroll_left = _get_scroll_offset($this[0]).left;
            }

            return scroll_left;
        },

        set_value: function(value) {
            return this.set_attribute('value', value);
        },

        get_value: function() {
            return this.get_attribute('value');
        },

        add_event: function(type, listener) {
            var $this  = this,
                $types = type.split(','),
                event_listener;

            event_listener = function(event) {
                listener.call(this, event);
            };

            for (var i = 0, len = $this.length; i < len; i++) {
                for (var j = 0, types_len = $types.length; j < types_len; j++) {
                    type = _get_event_type($types[j].trim());

                    $this[i].addEventListener(type, event_listener, false);
                }
            }
        },
    };

    // Ladet JavaScript-Code nach

    $$.load_script = function(url, callback) {
        var $head   = document.getElementsByTagName('head')[0],
            $script = document.createElement('script');

        $script.src = (navigator.userAgent.indexOf('MSIE ') > 0) ? url + '?' + Math.random() : url;

        if (callback && typeof(callback) === 'function') {
            $script.onload = callback;
        }

        $head.appendChild($script);
    };

    // Ajax

    $$.get = function(url, callback) {
        if (window.XMLHttpRequest) {
            var $ajax = new XMLHttpRequest();

            $ajax.open('GET', url, true);

            $ajax.onload = function() {
                if (this.status === 200) {
                    callback.call(this, this.responseText);
                }
            };

            $ajax.send();
        }
    };

    // Setzt hash

    $$.set_hash = function(hash) {
        if (window.history && window.history.replaceState) { // IE 10+
            hash = hash || window.location.pathname;
            window.history.replaceState(null, document.title, hash);
        }
    };

    // Verbindet zwei Objekte

    $$.merge_objects = function($obj1, $obj2) {
        for (var key in $obj2) {
            if ($obj2[key].constructor === Object) {
                $obj2[key] = $$.merge_objects($obj1[key], $obj2[key]);
            }
            else {
                $obj1[key] = $obj2[key];
            }
        }

        return $obj1;
    };

    // Scrollt zu

    $$.scroll_to = function(to, duration, callback) {
        var diff = to - $$(window).get_scroll_top(),
            step = diff / duration * 10;

        setTimeout(function() {
            window.scrollBy(0, step);

            if (Math.abs(diff) <= Math.abs(step)) {

                if (typeof callback === 'function') {
                    callback();
                }

                return;
            }

            $$.scroll_to(to, duration - 10, callback);
        }, 10);
    };


    // Gibt die Touch-Richtung zurück

    $$.get_touch_range = function(dist_x, dist_y) {
        var theta = Math.atan2(-dist_x, dist_y),
            degrees;

        if (theta < 0) {
            theta += 2 * Math.PI;
        }

        degrees = Math.floor(theta * (180 / Math.PI) - 180);

        if (degrees < 0 && degrees > -180) {
            degrees = 360 - Math.abs(degrees);
        }

        return {
            is_top    : degrees <= 40 || degrees >= 320,
            is_right  : degrees >= 50 && degrees <= 130,
            is_bottom : degrees >= 140 && degrees <= 220,
            is_left   : degrees >= 230 && degrees <= 310
        };
    };

    window.$$ = $$;
}(document, window));

// DEVICE
// -------------------------------------------------------------------------------------------------

(function(document, navigator, window) {
    var $html = document.querySelector('html');

    function _find(needle) {
        return navigator.userAgent.toLowerCase().indexOf(needle) !== -1;
    }

    window.device = {};

    device.iphone         = _find('iphone');
    device.ipod           = _find('ipod');
    device.ipad           = _find('ipad');
    device.ios            = device.iphone || device.ipod || device.ipad;
    device.android        = _find('android');
    device.android_phone  = device.android && _find('mobile');
    device.android_tablet = device.android && !_find('mobile');
    device.windows        = _find('windows');
    device.windows_phone  = device.windows && _find('phone');
    device.windows_tablet = device.windows && _find('touch');
    device.mobile         = device.android_phone || device.iphone || device.ipod || device.windows_phone;
    device.tablet         = device.ipad || device.android_tablet || device.windows_tablet;

    if (device.ios) {
        if (device.ipad) {
            $html.classList.add('ios', 'ipad', 'tablet');
        }
        else if (device.iphone || device.ipod) {
            $html.classList.add('ios', 'iphone', 'mobile');
        }
    }
    else if (device.android) {
        if (device.android_tablet) {
            $html.classList.add('android', 'tablet');
        }
        else {
            $html.classList.add('android', 'mobile');
        }
    }
    else if (device.windows) {
        if (device.windows_tablet) {
            $html.classList.add('windows', 'tablet');
        }
        else if (device.windows_phone) {
            $html.classList.add('windows', 'mobile');
        }
        else {
            $html.classList.add('desktop');
        }
    }
    else {
        $html.classList.add('desktop');
    }
}(document, navigator, window));

// BROWSER SUPPORT
// -------------------------------------------------------------------------------------------------

(function(document, navigator, window) {
    var $html  = document.querySelector('html'),
        $div   = document.createElement('div');

    // Überprüft die Browser-Unterstützung für CSS-Attribute wie z. B. transition

    function _has_css_property(property) {
        var css_property_found = false,
            prefixes           = ['Moz', 'Webkit'];

        if (property in $div.style) {
            css_property_found = true;
        }
        else {
            property = property.charAt(0).toUpperCase() + property.substr(1);

            for (var i = 0, len = prefixes.length; i < len; i++) {
                if (typeof $div.style[prefixes[i] + property] !== 'undefined') {
                    css_property_found = true;
                    break;
                }
            }
        }

        return css_property_found;
    }

    window.support = {
        touch      : window.navigator.msMaxTouchPoints || 'ontouchstart' in document.documentElement,
        transition : _has_css_property('transition') && 'TransitionEvent' in window   // TransitionEvent wird benötigt für Android 4.1.x (https://bugs.dojotoolkit.org/ticket/17164#comment:13)
    };

    // Setzt Klassen auf den HTML-Tag

    $html.classList.remove('no_js');
    $html.classList.add(support.touch ? 'touch' : 'no_touch');
    $html.classList.add(support.transition ? 'csstransitions' : 'no_csstransitions');
}(document, navigator, window));

// PREFETCH
// -------------------------------------------------------------------------------------------------

(function(document) {
    var Prefetch = function($prefetch_link) {
        var _this = this;

        _this._$prefetch_link = $prefetch_link;
        _this._$options       = _this._$prefetch_link.getAttribute('data-performance');
    };

    Prefetch.prototype = {
        init: function() {
            var _this = this;

            if (_this._$options.indexOf('prefetch') > -1) {
                _this._prefetch();
            }

            if (_this._$options.indexOf('prerender') > -1) {
                _this._prerender();
            }
        },

        _prefetch: function() {
            var _this = this,
                $link = document.createElement('link');

            $link.setAttribute('rel', 'prefetch');
            $link.setAttribute('href', _this._$prefetch_link.getAttribute('href'));

            document.querySelector('head').appendChild($link);
        },

        _prerender: function() {
            var _this = this,
                $link = document.createElement('link');

            $link.setAttribute('rel', 'prerender');
            $link.setAttribute('href', _this._$prefetch_link.getAttribute('href'));

            document.querySelector('head').appendChild($link);
        }
    };

    var $prefetch_links = document.querySelectorAll('[data-performance]');

    for (var i = 0, len = $prefetch_links.length; i < len; i++) {
        new Prefetch($prefetch_links[i]).init();
    }
})(document);

// BARRIEREFREIHEIT
// Wird gebraucht für alle Projekte

// EXTERNER LINK
// -------------------------------------------------------------------------------------------------

(function(document) {
    var $links = document.querySelectorAll('[href*=http]');

    for (var i = 0, $link; $link = $links[i]; i++) {
        var target = $link.getAttribute('target'),
            title  = $link.getAttribute('title');

        if (title && target === '_blank') {
            $link.setAttribute('title', title + ' (Neues Fenster)');
        }
    }
})(document);


// TASTATURSTEUERUNG FÜR ELEMENTE MIT ROLE BUTTON
// -------------------------------------------------------------------------------------------------

(function(document) {
    var $buttons = document.querySelectorAll('[role="button"]');

    for (var i = 0, $button; $button = $buttons[i]; i++) {
         $button.addEventListener('keyup', function(event) {
             if (event.keyCode === 13 && this.tagName !== 'A' || event.keyCode === 32) {
                 this.click();
             }
         });
     }
})(document);


// ERKENNUNG DER FOKUSMETHODE FÜR LINKS
// Wird verwendet für verbesserten Fokus auf Links (siehe default.less)
// -------------------------------------------------------------------------------------------------

(function(document) {
    var FocusMethod = function($link) {
        var _this = this;

        _this.$link = $link;

        _this.focus_method      = false;
        _this.last_focus_method = false;
    };

    FocusMethod.prototype = {
        init: function() {
            var _this = this;

            _this.$link.addEventListener('keydown',
                _this._on_key_down.bind(this), {
                    'passive' : true
                }
            );

            _this.$link.addEventListener('mousedown',
                _this._on_mouse_down.bind(this), {
                    'passive' : true
                }
            );

            _this.$link.addEventListener('touchstart',
                _this._on_touch_start.bind(this), {
                    'passive' : true
                }
            );

            _this.$link.addEventListener('focus', _this._on_focus.bind(this));
            _this.$link.addEventListener('blur', _this._on_blur.bind(this));

            window.addEventListener('blur', this._on_window_blur.bind(this));
        },

        _on_key_down: function() {
            var _this = this;

            _this.focus_method = 'key';
        },

        _on_mouse_down: function() {
            var _this = this;

            if (_this.focus_method === 'touch') {
                return;
            }

            _this.focus_method = 'mouse';
        },

        _on_touch_start: function() {
            var _this = this;

            _this.focus_method = 'touch';
        },

        _on_focus: function() {
            var _this = this;

            if (!_this.focus_method) {
                _this.focus_method = _this.last_focus_method;
            }

            _this.$link.setAttribute('data-focus-method', _this.focus_method);

            this.last_focus_method = this.focus_method;
            this.focus_method      = false;
        },

        _on_blur: function() {
            var _this = this;

            _this.$link.removeAttribute('data-focus-method');
        },

        _on_window_blur: function() {
            var _this = this;

            _this.focus_method = false;
        }
    };

    var $links = document.querySelectorAll('a, [tabindex="0"]');

    for (var i = 0, $link; $link = $links[i]; i++) {
        new FocusMethod($link).init();
    }
})(document);

// COOKIE-HINWEIS
// -------------------------------------------------------------------------------------------------

(function(document) {
    var $cookie_banner = document.querySelector('#cookie_banner'),
        $body          = document.querySelector('body');

    if (!$cookie_banner) {
        return;
    }

    var $close  = $cookie_banner.querySelector('.close'),
        now     = new Date().getTime(),
        storage = localStorage.getItem(domain + '_cookie_banner');

    if (storage === null || now > storage) {
        $cookie_banner.classList.remove('hideme');
        $body.classList.add('cb_visible');
    }

    $close.addEventListener('click', function(event) {
        event.preventDefault();

        localStorage.setItem(domain + '_cookie_banner', now + 31536000);
        $cookie_banner.classList.add('hideme');
        $body.classList.remove('cb_visible');
    });
}(document));

// COOKIE-HINWEIS FUSSZEILE VERLÄNGERN
// -------------------------------------------------------------------------------------------------

(function(document) {
    var $cookie_banner  = document.querySelector('#cookie_banner'),
        $footer         = document.querySelector('footer'),
        $close          = $cookie_banner.querySelector('.close'),
        $cookie_spacing;

    if (!$cookie_banner) {
        return;
    }

    $close.addEventListener('click', function() {
        if ($footer) {
            $footer.removeChild($cookie_spacing);
        }
    });

    if ($footer) {
        $cookie_spacing = document.createElement('div');
        $footer.appendChild($cookie_spacing);
        $cookie_spacing.style.paddingBottom = $cookie_banner.clientHeight + 'px';
        window.addEventListener('resize', function() {
            $cookie_spacing.style.paddingBottom = $cookie_banner.clientHeight + 'px';
        }, false);
    }

}(document));

// SEO: KEYWORDS IN STEUERNEWS ARTIKEL HERVORHEBEN
// -------------------------------------------------------------------------------------------------

(function(document) {
    var SeoHighlightKeywords = function($article) {
        var _this = this;

        _this.$article     = $article;
        _this.current_url  = document.location.href;
        _this.previous_url = document.referrer;
    };

    SeoHighlightKeywords.prototype = {
        init: function() {
            var _this = this;

            if (_this.previous_url.indexOf('/thema/') > -1 &&
                _this.current_url.indexOf('/thema/') === -1) {

                var keyword = _this._get_keyword(),
                    regex   = new RegExp('(?![^<]*>)' + '(' + keyword + ')', 'gi');

                _this.$article.innerHTML = _this.$article.innerHTML.replace(regex , '<span class="highlight_keyword">$1</span>');
            }
        },

        _get_keyword: function() {
            var _this    = this,
                keywords = _this.previous_url.split('/thema/');

            return decodeURIComponent(keywords[1]);
        }
    };

    var $article = document.getElementById('highlight_keywords');

    if ($article) { // has_seo raus, wenn SEO-Baustein
        new SeoHighlightKeywords($article).init();
    }
})(document);

// TOOLTIP
// Wird gebraucht für: google_maps,newsletter_quick_subscribe, formular
// -------------------------------------------------------------------------------------------------

(function(document) {
    var Tooltip = function($tooltip_wrapper) {
        var _this = this;

        _this.$tooltip_wrapper = $tooltip_wrapper;
        _this.$tooltip         = $tooltip_wrapper.querySelector('[role="tooltip"]');

        _this._temp_disabled = false;
        _this._perm_disabled = false;
        _this._focused       = false;

        var tooltip_id = _this.$tooltip.getAttribute('id');

        _this.$tooltip_trigger = $tooltip_wrapper.querySelector('[aria-describedby="' + tooltip_id + '"]');
    };

    Tooltip.prototype = {
        init: function() {
            var _this = this;

            _this.$tooltip_trigger.addEventListener('keyup', _this._check_tooltip.bind(_this));
            _this.$tooltip_trigger.addEventListener('focus', _this._check_tooltip.bind(_this));
            _this.$tooltip_trigger.addEventListener('blur', _this._hide_tooltip.bind(_this));

            if (!support.touch) {
                _this.$tooltip.addEventListener('mouseenter', _this._check_tooltip.bind(_this));
                _this.$tooltip.addEventListener('mouseleave', _this._hide_tooltip.bind(_this));
                _this.$tooltip_trigger.addEventListener('mouseenter', _this._check_tooltip.bind(_this));
                _this.$tooltip_trigger.addEventListener('mouseleave', _this._hide_tooltip.bind(_this));
            }

            _this._keyboard_nav();
        },

        _check_tooltip: function(event) {
            var _this = this;

            if (_this.$tooltip_trigger.getAttribute('aria-invalid') === 'true') {
                _this._perm_disabled = false;
                _this._show_tooltip(event);
            }
            else {
                _this._perm_disabled = true;
                _this._hide_tooltip(event);
            }
        },

        _show_tooltip: function(event) {
            var _this = this;

            if (_this.disabled) {
                return;
            }

            if (event.type === 'keyup' || event.type === 'focus') {
                _this._focused = true;
            }

            if (!_this._temp_disabled && !_this._perm_disabled ||
                event.type === 'mouseenter' && !_this._perm_disabled) {
                _this.$tooltip.setAttribute('aria-hidden', 'false');
            }
        },

        _hide_tooltip: function(event) {
            var _this = this;

            if (event.type === 'blur') {
                _this._temp_disabled = false;
                _this._focused = false;
            }

            if (!_this._focused || _this._perm_disabled || _this._temp_disabled) {
                _this.$tooltip.setAttribute('aria-hidden', 'true');
            }
        },

        _keyboard_nav: function() {
            var _this = this;

            _this.$tooltip_trigger.addEventListener('keydown', function(event) {
                if (event.keyCode === 27 && _this.$tooltip.getAttribute('aria-hidden') === 'false') {
                    event.stopPropagation();

                    _this._temp_disabled = true;
                    _this._hide_tooltip(event);
                }
            });
        }
    };

    var $tooltip_wrappers = document.querySelectorAll('.tooltip_wrapper');

    for (var i = 0, len = $tooltip_wrappers.length; i < len; i++) {
        new Tooltip($tooltip_wrappers[i]).init();
    }

    window.Tooltip = Tooltip;
})(document);

// DROPDOWN MENU
// -------------------------------------------------------------------------------------------------

(function(document) {
    var DropdownMenu = function($dropdown_menu) {
        var _this = this,
            id    = $dropdown_menu.getAttribute('id');

        _this.$dropdown_menu                   = $dropdown_menu;
        _this.$main_menuitems                  = $dropdown_menu.querySelectorAll('#' + id + ' > ul > li > a');
        _this.$sub_menuitems                   = $dropdown_menu.querySelectorAll('#' + id + ' > ul > li li > a');
        _this.$sub_menuitems_with_sub_sub_menu = $dropdown_menu.querySelectorAll('#' + id + ' > ul > li li > a.has_sub_sub_menu');
        _this.$main_menuitems_with_sub_menu    = $dropdown_menu.querySelectorAll('[href^="#"]');
        _this.main_menu_index                  = 0;
        _this.event_type                       = false;

        _this.$key = {
            'tab'         : 9,
            'enter'       : 13,
            'escape'      : 27,
            'space'       : 32,
            'arrow_left'  : 37,
            'arrow_up'    : 38,
            'arrow_right' : 39,
            'arrow_down'  : 40
        };
    };

    DropdownMenu.prototype = {
        init: function() {
            var _this = this;

            _this._init_accessibility();
            _this._init_keyboard();

            for (var i = 0, $main_menuitem; $main_menuitem = _this.$main_menuitems[i]; i++) {
                var $li = $main_menuitem.parentElement;

                $li.addEventListener('mouseenter',
                    _this._on_mouseenter_main_menuitem.bind(_this, $main_menuitem)
                );

                $li.addEventListener('mouseover',
                    _this._on_mouseover_main_menuitem.bind(_this, $main_menuitem)
                );

                $li.addEventListener('mouseout',
                    _this._on_mouseout_main_menuitem.bind(_this)
                );

                $main_menuitem.addEventListener('focus',
                    _this._on_focus_main_menuitem.bind(_this, $main_menuitem)
                );
            }
        },

        _init_accessibility: function() {
            var _this = this;

            for (var i = 0, $main_menuitem; $main_menuitem = _this.$main_menuitems_with_sub_menu[i]; i++) {
                $main_menuitem.setAttribute('aria-expanded', 'false');

                $main_menuitem.addEventListener('click', function(event) {
                    event.preventDefault();
                });
            }
        },

        _init_keyboard: function() {
            var _this = this;

            for (var i = 0, $main_menuitem; $main_menuitem = _this.$main_menuitems[i]; i++) {
                $main_menuitem.addEventListener('keydown',
                    _this._on_keydown_main_menuitem.bind(_this, $main_menuitem)
                );
            }

            for (var j = 0, $sub_menuitem; $sub_menuitem = _this.$sub_menuitems[j]; j++) {
                $sub_menuitem.addEventListener('keydown',
                    _this._on_keydown_sub_menuitem.bind(_this, $sub_menuitem)
                );
            }
        },

        _on_keydown_main_menuitem: function($main_menuitem, event) {
            var _this = this;

            _this.event_type      = event.type;
            _this.main_menu_index = _this._get_main_menuitem_index();
            _this.$main_menuitem  = $main_menuitem;
            _this.$sub_menu       = $main_menuitem.nextElementSibling;

            switch(event.keyCode) {
                case _this.$key.tab:
                    if (event.shiftKey) {
                        _this.main_menu_index -= 1;
                    }
                    else {
                        _this.main_menu_index += 1;
                    }

                    break;

                case _this.$key.enter:
                    if (_this.$sub_menu) {
                        event.preventDefault();
                        _this._close_sub_menus();
                        this._open_sub_menu(false);
                    }

                    break;

                case _this.$key.escape:
                    event.preventDefault();

                    if (_this.sub_menu_is_open) {
                        event.stopPropagation();
                    }

                    _this._close_sub_menu();

                    break;

                case _this.$key.arrow_left:
                    event.preventDefault();

                    _this._focus_prev_main_menuitem();

                    break;

                case _this.$key.arrow_up:
                    event.preventDefault();

                    if (_this.sub_menu_is_open) {
                        _this._focus_prev_menuitem();
                    }

                    break;

                case _this.$key.arrow_right:
                    event.preventDefault();

                    _this._focus_next_main_menuitem();

                    break;

                case _this.$key.arrow_down:
                    event.preventDefault();

                    if (_this.$sub_menu) {
                        this._open_sub_menu(false);
                    }
                    else {
                        _this._focus_next_main_menuitem();
                    }

                    break;
            }
        },

        _get_main_menuitem_index: function() {
            var _this = this;

            return Array.prototype.indexOf.call(_this.$main_menuitems, document.activeElement);
        },

        _focus_prev_menuitem: function() {
            var _this = this;

            _this.main_menu_index -= 1;

            if (_this.main_menu_index < 0) {
                _this.main_menu_index = 0;

                return;
            }

            _this.$main_menuitem = _this.$main_menuitems[_this.main_menu_index];
            _this.$sub_menu      = _this.$main_menuitem.nextElementSibling;

            if (_this.$sub_menu && _this.sub_menu_is_open) {
                this._open_sub_menu(true);
            }
            else {
                _this.$main_menuitem.focus();
            }
        },

        _focus_prev_main_menuitem: function() {
            var _this = this;

            _this.main_menu_index -= 1;

            if (_this.main_menu_index < 0) {
                _this.main_menu_index = 0;

                return;
            }

            _this.$main_menuitem = _this.$main_menuitems[_this.main_menu_index];

            _this.$main_menuitem.focus();
        },

        _focus_next_main_menuitem: function() {
            var _this = this;

            _this.main_menu_index += 1;

            if (_this.main_menu_index === _this.$main_menuitems.length) {
                _this.main_menu_index = _this.$main_menuitems.length - 1;

                return;
            }

            _this.$main_menuitem = _this.$main_menuitems[_this.main_menu_index];

            _this.$main_menuitem.focus();
        },

        _on_mouseenter_main_menuitem: function($main_menuitem, event) {
            var _this = this;

            _this.event_type     = event.type;
            _this.$main_menuitem = $main_menuitem;
            _this.$sub_menu      = $main_menuitem.nextElementSibling;

            _this._close_sub_menus();

            if (_this.$sub_menu) {
                _this._open_sub_menu(false);
            }
        },

        _on_mouseover_main_menuitem: function() {
            var _this = this;

            clearTimeout(_this.close_sub_menu_timeout);
        },

        _on_mouseout_main_menuitem: function() {
            var _this = this;

            _this.close_sub_menu_timeout = setTimeout(function() {
                _this._close_sub_menus();
            }, 1000);
        },

        _on_focus_main_menuitem: function($main_menuitem, event) {
            var _this = this;

            _this.event_type = event.type;

            if (_this.sub_menu_is_open) {
                _this.$main_menuitem = $main_menuitem;
                _this.$sub_menu      = $main_menuitem.nextElementSibling;

                _this._close_sub_menus();

                if (_this.$sub_menu) {
                    _this._open_sub_menu();
                }
            }
        },

        _on_keydown_sub_menuitem: function($sub_menuitem, event) {
            var _this = this;

            switch(event.keyCode) {
                case _this.$key.tab:

                    if (event.shiftKey) {
                        _this.sub_menu_index -= 1;
                    }
                    else {
                        _this.sub_menu_index += 1;
                    }

                    break;

                case _this.$key.escape:
                    event.preventDefault();
                    event.stopPropagation();

                    _this._close_sub_menu();

                    break;

                case _this.$key.arrow_left:
                    event.preventDefault();

                    _this.sub_menu_index = 0;
                    _this._focus_prev_sub_menuitem();

                    break;

                case _this.$key.arrow_up:
                    event.preventDefault();

                    _this._focus_prev_sub_menuitem();

                    break;

                case _this.$key.arrow_right:
                    event.preventDefault();

                    _this.sub_menu_index = 0;
                    _this._focus_prev_sub_menuitem();

                    break;

                case _this.$key.arrow_down:
                    event.preventDefault();

                    _this._focus_next_sub_menuitem();

                    break;
            }

            _this._open_sub_sub_menu();
        },

        _open_sub_sub_menu: function() {
            var _this          = this;
                $sub_menuitem  = _this.$main_menuitem.nextElementSibling.querySelectorAll('li li > a')[_this.sub_menu_index];

            if($sub_menuitem) {

                for (var i = 0, $menuitem; $menuitem = _this.$sub_menuitems[i]; i++) {
                    var is_current_menuitem    = $sub_menuitem === $menuitem,
                        $sub_sub_menu          = $sub_menuitem.parentNode.querySelector('ul');
                        is_sub_sub_menuitem    = $sub_menuitem.classList.contains('sub_sub_menuitem');

                    if (is_current_menuitem && $sub_sub_menu) {
                        $menuitem.parentElement.classList.add('hover');
                        $menuitem.setAttribute('aria-expanded', true);
                    }

                    else if (is_current_menuitem && is_sub_sub_menuitem) {
                        $menuitem.parentElement.parentElement.parentElement.classList.add('hover');
                        $menuitem.parentElement.parentElement.parentElement.setAttribute('aria-expanded', true);
                    }

                    else {
                        $menuitem.parentElement.classList.remove('hover');
                        $menuitem.setAttribute('aria-expanded', false);
                    }
                }
            }

            else {
                _this._close_sub_sub_menus();
            }
        },

        _close_sub_sub_menus: function() {
            var _this = this;

            for (var i = 0, $sub_menuitem; $sub_menuitem = _this.$sub_menuitems_with_sub_sub_menu[i]; i++) {
                $sub_menuitem.parentElement.classList.remove('hover');
                $sub_menuitem.setAttribute('aria-expanded', 'false');
            }
        },

        _focus_prev_sub_menuitem: function() {
            var _this          = this,
                $sub_menuitems = _this.$main_menuitem.nextElementSibling.querySelectorAll('a'),
                $sub_menuitem,
                $main_menuitem;

            _this.sub_menu_index -= 1;

            $sub_menuitem = $sub_menuitems[_this.sub_menu_index];

            if (_this.sub_menu_index < 0) {
                $main_menuitem = _this.$main_menuitems[_this.main_menu_index];

                if ($main_menuitem) {
                    $main_menuitem.focus();
                }
            }
            else if ($sub_menuitem) {
                $sub_menuitem.focus();
            }
        },

        _focus_next_sub_menuitem: function() {
            var _this          = this,
                $sub_menuitems = _this.$main_menuitem.nextElementSibling.querySelectorAll('a'),
                $sub_menuitem,
                $main_menuitem;

            _this.sub_menu_index += 1;

            $sub_menuitem = $sub_menuitems[_this.sub_menu_index];

            if (_this.sub_menu_index === $sub_menuitems.length) {
                _this.main_menu_index += 1;

                $main_menuitem = _this.$main_menuitems[_this.main_menu_index];

                if ($main_menuitem) {
                    $main_menuitem.focus();
                }
                else {
                    _this.main_menu_index -= 1;
                    _this.sub_menu_index  -= 1;
                }
            }
            else {
                $sub_menuitem.focus();
            }
        },

        _open_sub_menu: function(focus_last_sub_menuitem) {
            var _this = this,
                $sub_menuitems;

            for (var i = 0, $main_menuitem; $main_menuitem = _this.$main_menuitems_with_sub_menu[i]; i++) {
                var is_current_menuitem = _this.$main_menuitem === $main_menuitem;

                if (is_current_menuitem) {
                    $main_menuitem.parentElement.classList.add('hover');
                }
                else {
                    $main_menuitem.parentElement.classList.remove('hover');
                }

                $main_menuitem.setAttribute('aria-expanded', is_current_menuitem);
            }

            _this.sub_menu_index = 0;

            if (_this.event_type === 'keydown') {
                $sub_menuitems = _this.$sub_menu.querySelectorAll('a');

                if (focus_last_sub_menuitem) {
                    _this.sub_menu_index = $sub_menuitems.length - 1;
                }

                $sub_menuitems[_this.sub_menu_index].focus();

                _this.event_type = false;
            }

            _this.sub_menu_is_open = true;
        },

        _close_sub_menu: function() {
            var _this = this;

            _this.$main_menuitem.parentElement.classList.remove('hover');
            _this.$main_menuitem.setAttribute('aria-expanded', 'false');

            _this.sub_menu_is_open = false;

            _this.$main_menuitem.focus();
        },

        _close_sub_menus: function() {
            var _this = this;

            for (var i = 0, $main_menuitem; $main_menuitem = _this.$main_menuitems_with_sub_menu[i]; i++) {
                $main_menuitem.parentElement.classList.remove('hover');
                $main_menuitem.setAttribute('aria-expanded', 'false');
            }

            _this._close_sub_sub_menus();
        }
    };

    var $dropdown_menu = document.getElementsByClassName('dropdown_menu');

    for (var i = 0, len = $dropdown_menu.length; i < len; i++) {
        new DropdownMenu($dropdown_menu[i]).init();
    }
})(document);

// OFFCANVAS MENU ACORDION
// MUSS VOR DEM EIGENTLICHEN ACORDION GELADEN WERDEN
// -------------------------------------------------------------------------------------------------

(function(document) {
    var OffCanvasMenuAccordion = function($toggle_offcanvas_menu) {
        var _this = this,
            controls;

        controls = $toggle_offcanvas_menu.querySelector('.open_offcanvas_menu').getAttribute('aria-controls');

        _this.$main_menuitems_with_sub_menu = document.getElementById(controls).querySelectorAll('[href^="#"]');
    };

    OffCanvasMenuAccordion.prototype = {
        init: function() {
            var _this = this;

            _this._init_accessibility();

            for (var j = 0, $main_menuitem_with_sub_menu; $main_menuitem_with_sub_menu = _this.$main_menuitems_with_sub_menu[j]; j++) {
                $main_menuitem_with_sub_menu.addEventListener('click',
                    _this._on_click_main_menuitem.bind(_this, $main_menuitem_with_sub_menu)
                );
            }

            window.addEventListener('resize',
                _this._window_size_changed.bind(_this, $main_menuitem_with_sub_menu)
            );

        },

        _init_accessibility: function() {
            var _this = this;

            for (var i = 0, $main_menuitem; $main_menuitem = _this.$main_menuitems_with_sub_menu[i]; i++) {
                if ($main_menuitem.classList.contains('active')) {
                    $element = $main_menuitem.parentElement.querySelector('ul');
                    $element.style.height = $element.scrollHeight + 'px';
                }
            }
        },

        _window_size_changed: function() {
            var _this = this;

            for (var i = 0, $main_menuitem; $main_menuitem = _this.$main_menuitems_with_sub_menu[i]; i++) {
                if ($main_menuitem.getAttribute('aria-expanded') === 'true') {
                    var $element = $main_menuitem.parentElement.querySelector('ul');
                    // reset height font.size manipulates height of element
                    $element.style.height = 'auto';
                    $element.style.height = $element.scrollHeight + 'px';
                }
            }
        },

        _on_click_main_menuitem: function($main_menuitem_selected) {
            var _this = this;

            for (var i = 0, $main_menuitem; $main_menuitem = _this.$main_menuitems_with_sub_menu[i]; i++) {
                var $element = $main_menuitem.parentElement.querySelector('ul');

                if ($main_menuitem_selected === $main_menuitem) {
                    $element.style.height = '0px';
                    if ($main_menuitem.getAttribute('aria-expanded') === 'false') {
                        $element.style.height = $element.scrollHeight + 'px';
                    } else {
                        $element.style.height = '0px';
                    }
                }
                else {
                    $element.style.height = '0px';
                }
            }
        }
    };

    // init OffCanvasMenu only once
    new OffCanvasMenuAccordion(document.getElementsByClassName('toggle_offcanvas_menu')[0]).init();
    var $toggle_offcanvas_menu = document.getElementsByClassName('toggle_offcanvas_menu');

    // create an Opener for each button
    for (var i = 0, len = $toggle_offcanvas_menu.length; i < len; i++) {
        new OffCanvasMenuAccordion($toggle_offcanvas_menu[i]).init();
    }

})(document);

// OFFCANVAS MENU
// -------------------------------------------------------------------------------------------------

(function(document) {
    var OffCanvasMenu = function($toggle_offcanvas_menu) {
        var _this = this,
            controls;

        controls = $toggle_offcanvas_menu.querySelector('.open_offcanvas_menu').getAttribute('aria-controls');

        _this.$offcanvas_menu               = document.getElementById(controls);
        _this.$main_menuitems_with_sub_menu = _this.$offcanvas_menu.querySelectorAll('[href^="#"]');
        // _this.$offcanvas_menu_content       = _this.$offcanvas_menu.querySelector('.offcanvas_menu_content');
        _this.$focus_elements               = _this.$offcanvas_menu.querySelectorAll('a');
        _this.focus_element                 = false;
        _this.$offcanvas_menu_state         = false;

        _this.$key = {
            'tab'    : 9,
        };
    };

    OffCanvasMenu.prototype = {
        init: function() {
            var _this = this;

            _this._init_accessibility();
            _this._init_keyboard();

            for (var j = 0, $main_menuitem_with_sub_menu; $main_menuitem_with_sub_menu = _this.$main_menuitems_with_sub_menu[j]; j++) {
                $main_menuitem_with_sub_menu.addEventListener('click',
                    _this._on_click_main_menuitem.bind(_this, $main_menuitem_with_sub_menu)
                );
            }
        },

        _init_accessibility: function() {
            var _this = this;

            for (var i = 0, $main_menuitem; $main_menuitem = _this.$main_menuitems_with_sub_menu[i]; i++) {
                $main_menuitem.setAttribute('aria-expanded', $main_menuitem.classList.contains('active'));
            }
        },

        _init_keyboard: function() {
            var _this = this;

            document.addEventListener('keydown', function(event) {
                if (!_this.$offcanvas_menu_state.checked) {
                    return;
                }

                if (event.keyCode === _this.$key.tab) {
                    event.preventDefault();

                    if (event.shiftKey) {
                        _this._focus_element_with_shift_tab_key(event);
                    }
                    else {
                        _this._focus_element_with_tab_key(event);
                    }
                }
            });
        },

        _focus_element_with_shift_tab_key: function() {
            var _this = this;

            _this.tab_index -= 1;

            if (_this.tab_index < 0) {
                _this.tab_index = _this.$focus_elements.length - 1;
            }

            for (var i = _this.tab_index, $focus_element; $focus_element = _this.$focus_elements[i]; i--) {
                if ($focus_element.offsetParent === null || $focus_element.offsetWidth === 0) {
                    _this.tab_index -= 1;
                    continue;
                }

                _this.$focus_elements[_this.tab_index].focus();
                break;
            }
        },

        _focus_element_with_tab_key: function() {
            var _this = this;

            if (_this.tab_index === _this.$focus_elements.length - 1) {
                _this.tab_index = 0;
            }
            else {
                _this.tab_index += 1;
            }

            for (var i = _this.tab_index, $focus_element; $focus_element = _this.$focus_elements[i]; i++) {
                if ($focus_element.offsetParent === null || $focus_element.offsetWidth === 0) {
                    _this.tab_index += 1;

                    if (_this.tab_index > _this.$focus_elements.length - 1) {
                        _this.tab_index = 0;
                    }
                    else {
                        continue;
                    }
                }

                _this.$focus_elements[_this.tab_index].focus();
                break;
            }
        },

        _on_click_main_menuitem: function($main_menuitem, event) {
            var _this = this;

            event.preventDefault();

            _this.$main_menuitem = $main_menuitem;

            _this._toggle_sub_menus();
        },

        _toggle_sub_menus: function() {
            var _this = this;

            for (var i = 0, $main_menuitem; $main_menuitem = _this.$main_menuitems_with_sub_menu[i]; i++) {
                var is_active_menuitem = _this.$main_menuitem === $main_menuitem,
                    $parent_menuitems  = _this._get_parent_menu_elements();

                if (is_active_menuitem) {
                    _this.sub_menu_is_open = $main_menuitem.getAttribute('aria-expanded') === 'false';

                    $main_menuitem.parentElement.classList.toggle('expanded', _this.sub_menu_is_open);
                    $main_menuitem.setAttribute('aria-expanded', _this.sub_menu_is_open);
                }
                else if ($parent_menuitems.indexOf($main_menuitem) !== -1) { // Check parents
                    $main_menuitem.parentElement.classList.toggle('expanded', 'true');
                    $main_menuitem.setAttribute('aria-expanded', 'true');
                }
                else {
                    $main_menuitem.parentElement.classList.remove('expanded');
                    $main_menuitem.setAttribute('aria-expanded', 'false');
                }
            }
        },

        _get_parent_menu_elements: function() {
            var _this = this.$main_menuitem,
                $findings = [];

            while (_this.parentNode) {
                _this = _this.parentNode;

                if (_this.nodeName.toLowerCase() === 'li') {
                    $findings.push(_this.querySelector('a'));
                }
            }

            return $findings || False;
        }
    };

    var OffCanvasMenuOpener = function($toggle_offcanvas_menu) {
        var _this = this;
        var  controls = $toggle_offcanvas_menu.querySelector('.open_offcanvas_menu').getAttribute('aria-controls');

        _this.$toggle_offcanvas_menu = $toggle_offcanvas_menu.querySelector('label');
        _this.$open_offcanvas_menu   = $toggle_offcanvas_menu.querySelector('.open_offcanvas_menu');
        _this.$close_offcanvas_menu  = $toggle_offcanvas_menu.querySelector('.close_offcanvas_menu');
        _this.$offcanvas_menu_state  = document.querySelector('#' + _this.$toggle_offcanvas_menu.getAttribute('for'));
        _this.$offcanvas_menu        = document.getElementById(controls);
        _this.$focus_elements        = _this.$offcanvas_menu.querySelectorAll('a');

        _this.$key = {
            'enter'  : 13,
            'escape' : 27,
            'space'  : 32
        };
    };

    OffCanvasMenuOpener.prototype = {
        init: function() {
            var _this = this;

            _this._init_keyboard();

            _this.$toggle_offcanvas_menu.addEventListener('click', _this._toggle_menu.bind(_this));
            _this.$open_offcanvas_menu.addEventListener('click', _this._open_menu.bind(_this));
            _this.$close_offcanvas_menu.addEventListener('click', _this._close_menu.bind(_this));

            _this.$offcanvas_menu.addEventListener('transitionend', function(event) {

                // var _this = this;
                if (event.target !== this) {
                    return;
                }

                if (_this.$offcanvas_menu_state.checked) {
                    if (_this.focus_element) {
                        _this.focus_element = false;
                        _this.$focus_elements[0].focus();
                    }
                }
                else if (_this.focus_element) {
                    _this.focus_element = false;
                    _this.$open_offcanvas_menu.focus();
                }
            });
        },

        _init_keyboard: function() {
            var _this = this;

            _this.$open_offcanvas_menu.addEventListener('keydown', function(event) {
                if (event.keyCode === _this.$key.space || event.keyCode === _this.$key.enter) {
                    _this.focus_element = true;
                }

                if (event.keyCode === _this.$key.space) {
                    event.preventDefault();
                }
            });

            _this.$close_offcanvas_menu.addEventListener('keydown', function(event) {
                if (event.keyCode === _this.$key.space) {
                    event.preventDefault();
                }
            });

            document.addEventListener('keydown', function(event) {
                if (!_this.$offcanvas_menu_state.checked) {
                    return;
                }

                if (event.keyCode === _this.$key.escape) {
                    _this.focus_element = true;
                    _this._close_menu(event);
                }
            });
        },

        _scroll_to_top: function() {
            var _this = this;

            setTimeout(function() {
                var duration = 300,
                    interval;

                interval = setInterval(function() {
                    var diff = -window.pageYOffset,
                        step = diff / duration * 10;

                    if (Math.abs(diff) <= Math.abs(step)) {
                        if (_this.$anchor) {
                            _this.$anchor.focus();
                        }

                        clearInterval(interval);
                    }

                    window.scrollBy(0, step);
                    duration -= 10;
                }, 10);
            }, 300);
        },

        _toggle_menu: function(event) {
            var _this = this;

            if (_this.$offcanvas_menu_state.checked) {
                _this._close_menu(event);
            }
            else {
                _this._open_menu(event);
            }
        },

        _open_menu: function(event) {
            var _this = this;

            event.preventDefault();

            _this.$offcanvas_menu_state.checked = true;
            _this.tab_index = 0;

            _this._scroll_to_top();
        },

        _close_menu: function(event) {
            var _this = this;

            event.preventDefault();

            _this.$offcanvas_menu_state.checked = false;
            _this.tab_index = 0;
        }
    };

    var $offcanvas_menu = document.getElementsByClassName('toggle_offcanvas_menu');

    if ($offcanvas_menu.length) {
        new OffCanvasMenu($offcanvas_menu[0]).init(); // init once

        // create an opener for each button
        for (var i = 0, len = $offcanvas_menu.length; i < len; i++) {
            new OffCanvasMenuOpener($offcanvas_menu[i]).init();
        }
    }
})(document);

// FORMULARE
// -------------------------------------------------------------------------------------------------

(function() {
    var FormHelpers = function(element) {
        var _this = this;

        _this.$el = $$(element);
    };

    FormHelpers.prototype = {
        init: function() {
            var _this = this;

            _this._file_upload();
            _this._select();
        },

        _file_upload: function() {
            var _this = this;

            if (_this.$el.get_attribute('type') !== 'file') {
                return;
            }

            var $file_name   = _this.$el.get_parent().children('.file_name'),
                $file_button = _this.$el.get_parent().children('.file_button');

            _this.$el.add_event('focus', function() {
                $file_button.add_class('focus');
            });

            _this.$el.add_event('blur', function() {
                $file_button.remove_class('focus');
            });

            _this.$el.add_event('change', function() {
                $file_name.set_text(_this.$el.get_file().filename);
            });
        },

        _select: function() {
            var _this = this;

            if (!_this.$el.is_tag('select')) {
                return;
            }

            _this.$el.add_event('focus', function() {
                _this.$el.get_parent('.select').add_class('focus');
            });

            _this.$el.add_event('blur', function() {
                _this.$el.get_parent('.select').remove_class('focus');
            });
        }
    };

    $$('input, select, textarea').for_each(function() {
        new FormHelpers(this).init();
    });
})();

// FORM VALIDIERUNG
// -------------------------------------------------------------------------------------------------

(function(document, window) {
    var FormValidation = function($form) {
        var _this = this;

        _this._$form                    = $form;
        _this._$inputs                  = _this._$form.querySelectorAll('input.validate, textarea.validate');
        _this._$inputs_checkbox         = _this._$form.querySelectorAll('input[type=checkbox][required]');
        _this._$inputs_checkbox_wrapper = _this._$form.querySelectorAll('.checkbox_wrapper.required');
        _this._$inputs_email            = _this._$form.querySelectorAll('input[type=email]');
        _this._$selects                 = _this._$form.querySelectorAll('select[required]');
        _this._$button                  = _this._$form.querySelector('[type="submit"]');
        _this._$error_msg_button        = _this._$form.querySelector('.error_msg_button');
    };

    FormValidation.prototype = {
        init: function() {
            var _this = this;

            _this._init_validation();

            for (var j = 0, inputs_len = _this._$inputs.length; j < inputs_len; j++) {
                var $input = this._$inputs[j];

                $input.addEventListener('keyup', _this._input_keyup.bind(_this, $input));
                $input.addEventListener('blur', _this._input_blur.bind(_this, $input));
            }

            for (var i = 0, inputs_checkbox_len = _this._$inputs_checkbox.length; i < inputs_checkbox_len; i++) {
                var $input_checkbox = this._$inputs_checkbox[i];

                $input_checkbox.addEventListener('click', _this._input_checkbox_click.bind(_this, $input_checkbox));
                $input_checkbox.addEventListener('keyup', _this._input_checkbox_keyup.bind(_this, $input_checkbox));
                $input_checkbox.addEventListener('blur', _this._input_checkbox_blur.bind(_this, $input_checkbox));
            }

            for (var k = 0, inputs_checkbox_wrapper_len = _this._$inputs_checkbox_wrapper.length; k < inputs_checkbox_wrapper_len; k++) {
                var $inputs_checkbox_wrapper = _this._$inputs_checkbox_wrapper[k];
                var $wrapped_checkboxes = $inputs_checkbox_wrapper.querySelectorAll('input[type=checkbox]');

                for (var l = 0, wrapped_checkboxes_len = $wrapped_checkboxes.length; l < wrapped_checkboxes_len; l++) {
                    var $wrapped_checkbox = $wrapped_checkboxes[l];

                    $wrapped_checkbox.addEventListener('click', _this._input_wrapped_checkbox_click.bind(_this, $wrapped_checkbox, $inputs_checkbox_wrapper));
                    $wrapped_checkbox.addEventListener('keyup', _this._input_wrapped_checkbox_keyup.bind(_this, $wrapped_checkbox, $inputs_checkbox_wrapper));
                }
            }

            for (var x = 0, selects_len = _this._$selects.length; x < selects_len; x++) {
                var $select = this._$selects[x];

                $select.addEventListener('change', _this._select_change.bind(_this, $select));
                $select.addEventListener('blur', _this._select_blur.bind(_this, $select));
            }

            _this._$form.addEventListener('submit', _this._submit.bind(_this));

            _this._check_submit_status();
        },

        _init_validation: function() {
            var _this = this;

            _this._$form.noValidate = true;

            for (var i = 0; i < _this._$inputs_email.length; i++) {
                _this._$inputs_email[i].pattern = '@';
            }
        },

        _input_keyup: function($input, event) {
            if (event.keyCode === 9 || event.keyCode === 27) {
                // No validation on TAB or ESC
                return;
            }

            this._validate_input($input, event);
        },

        _input_blur: function($input, event) {
            this._validate_input($input, event);
        },

        _validate_input: function($input, event) {
            var _this          = this,
                id             = $input.getAttribute('id'),
                $error_warning = document.querySelector('[for="' + id + '"] .error_warning'),
                min            = parseInt($input.getAttribute('min')),
                pattern        = $input.getAttribute('pattern'),
                regexp         = new RegExp(pattern),
                value          = $input.value;

            if ($input.type === 'file') {
                _this._validate_input_file($input);
            }
            else if (value) {
                if (pattern && value.match(regexp) || value >= min || !pattern && $input.required) {
                    $input.setAttribute('aria-invalid', 'false');

                    if (!event || event.type === 'blur') {
                        $input.classList.remove('error');

                        if ($error_warning) {
                            $error_warning.classList.remove('show');
                        }
                    }
                }
                else {
                    $input.setAttribute('aria-invalid', 'true');

                    if (!event || event.type === 'blur') {
                        $input.classList.add('error');

                        if ($error_warning) {
                            $error_warning.classList.add('show');
                        }
                    }
                }
            }
            else if ($input.required) {
                $input.setAttribute('aria-invalid', 'true');

                if (!event || event.type === 'blur') {
                    $input.classList.add('error');

                    if ($error_warning) {
                        $error_warning.classList.add('show');
                    }
                }
            }
            else {
                $input.setAttribute('aria-invalid', 'false');

                if (!event || event.type === 'blur') {
                    $input.classList.remove('error');

                    if ($error_warning) {
                        $error_warning.classList.remove('show');
                    }
                }
            }
            _this._check_submit_status();
        },

        _validate_input_file: function($input) {
            var _this           = this,
                id              = $input.getAttribute('id'),
                $error_warning  = document.querySelector('[for="' + id + '"] .error_warning'),
                value           = $input.value;

            while ($input && $input.nodeType !== 9) {
                $input = $input.parentNode;

                if ($input.classList.contains('file')) {
                    break;
                }
            }

            if (value) {
                $input.classList.remove('error');
                if ($error_warning) {
                    $error_warning.classList.remove('show');
                }
            }
            else {
                $input.classList.add('error');
                if ($error_warning) {
                    $error_warning.classList.add('show');
                }
            }

            _this._check_submit_status();
        },

        _input_checkbox_click: function($input_checkbox, event) {
            this._validate_input_checkbox($input_checkbox, event);
        },

        _input_checkbox_keyup: function($input_checkbox, event) {
            if (event.keyCode === 32) { // SPACE
                this._validate_input_checkbox($input_checkbox, event);
            }
        },

        _input_checkbox_blur: function($input_checkbox, event) {
            this._validate_input_checkbox($input_checkbox, event);
        },

        _validate_input_checkbox: function($input_checkbox, event) {
            var _this             = this,
                id                = $input_checkbox.getAttribute('id'),
                $error_warning    = document.querySelector('#label_' + id + ' .error_warning');

            if ($input_checkbox.checked && !event ||
                $input_checkbox.checked && event && event.type !== 'keyup' ||
                !$input_checkbox.checked && event && event.type === 'keyup') {
                $input_checkbox.setAttribute('aria-invalid', 'false');
                $input_checkbox.classList.remove('error');
                $error_warning.classList.remove('show');
            }
            else {
                $input_checkbox.setAttribute('aria-invalid', 'true');
                $input_checkbox.classList.add('error');
                $error_warning.classList.add('show');
            }

            _this._check_submit_status();
        },

        _input_wrapped_checkbox_click: function($wrapped_checkbox, $parent, event) {
            this._validate_input_checkbox_wrapper($parent, event);
        },

        _input_wrapped_checkbox_keyup: function($wrapped_checkbox, $parent, event) {
            if (event.keyCode === 32) { // SPACE
                this._validate_input_checkbox($parent, event);
            }
        },

        _input_wrapped_checkbox_blur: function($wrapped_checkbox, $parent, event) {
            this._validate_input_checkbox($parent, event);
        },

        _validate_input_checkbox_wrapper: function($inputs_checkbox_wrapper) {
            var _this               = this,
                id                  = $inputs_checkbox_wrapper.getAttribute('id'),
                $error_warning      = document.querySelector('#label_' + id + ' .error_warning'),
                $checked_checkboxes = $inputs_checkbox_wrapper.querySelectorAll('input[type=checkbox]:checked');

            if ($checked_checkboxes.length >= 1) {
                $inputs_checkbox_wrapper.setAttribute('aria-invalid', 'false');
                $inputs_checkbox_wrapper.classList.remove('error');
                $error_warning.classList.remove('show');
            }
            else {
                $inputs_checkbox_wrapper.setAttribute('aria-invalid', 'true');
                $inputs_checkbox_wrapper.classList.add('error');
                $error_warning.classList.add('show');
            }

            _this._check_submit_status();
        },

        _select_change: function($select, event) {
            this._validate_select($select, event);
        },

        _select_blur: function($select, event) {
            this._validate_select($select, event);
        },

        _validate_select: function($select, event) {
            var _this          = this,
                id             = $select.getAttribute('id'),
                $wrapper       = $select,
                $error_warning = document.querySelector('#label_' + id + ' .error_warning'),
                value          = $select.value;

            while ($wrapper && $wrapper.nodeType !== 9) {
                $wrapper = $wrapper.parentNode;

                if ($wrapper.classList.contains('select')) {
                    break;
                }
            }

            if (value) {
                $select.setAttribute('aria-invalid', 'false');

                if (!event || event.type === 'blur') {
                    $wrapper.classList.remove('error');
                    $error_warning.classList.remove('show');
                }
            }
            else {
                $select.setAttribute('aria-invalid', 'true');

                if (!event || event.type === 'blur') {
                    $wrapper.classList.add('error');
                    $error_warning.classList.add('show');
                }
            }

            _this._check_submit_status();
        },

        _check_submit_status: function() {
            var _this                = this,
                error_msg_button_id  = _this._$error_msg_button.getAttribute('id'),
                enable_submit_button = true;

            for (var j = 0, inputs_len = _this._$inputs.length; j < inputs_len; j++) {
                if (_this._$inputs[j].getAttribute('aria-invalid') === 'true' ||
                    _this._$inputs[j].required && !_this._$inputs[j].value) {
                    enable_submit_button = false;
                    break;
                }
            }

            for (var k = 0, inputs_checkbox_wrapper_len = _this._$inputs_checkbox_wrapper.length; k < inputs_checkbox_wrapper_len; k++) {
                if (_this._$inputs_checkbox_wrapper[k].getAttribute('aria-invalid') === 'true') {
                    enable_submit_button = false;
                    break;
                }
            }

            for (var i = 0, inputs_checkbox_len = _this._$inputs_checkbox.length; i < inputs_checkbox_len; i++) {
                if (!_this._$inputs_checkbox[i].checked) {
                    enable_submit_button = false;
                    break;
                }
            }

            for (var x = 0, selects_len = _this._$selects.length; x < selects_len; x++) {
                if (!_this._$selects[x].value) {
                    enable_submit_button = false;
                    break;
                }
            }

            if (enable_submit_button) {
                _this._$button.classList.remove('disabled');
                _this._$button.removeAttribute('aria-describedby');
            }
            else {
                _this._$button.classList.add('disabled');
                _this._$button.setAttribute('aria-describedby', error_msg_button_id);
            }
        },

        _show_first_error: function() {
            var _this              = this,
                $first_input_error = _this._$form.querySelector('[aria-invalid="true"]'),
                top_position       = 0,
                offset_top         = 60,
                duration           = 300,
                interval,
                $obj;

            if ($first_input_error) {
                $obj         = $first_input_error;
                top_position = $obj.offsetTop - offset_top;

                while ($obj = $obj.offsetParent) {
                    top_position += $obj.offsetTop;
                }

                if (window.pageYOffset < top_position) {
                    $first_input_error.focus();
                    return;
                }

                interval = setInterval(function() {
                    var diff = top_position - window.pageYOffset,
                        step = diff / duration * 10;

                    if (Math.abs(diff) <= Math.abs(step)) {
                        $first_input_error.focus();
                        clearInterval(interval);
                    }

                    window.scrollBy(0, step);
                    duration -= 10;
                }, 10);
            }
        },

        _submit: function(event) {
            var _this = this;

            _this._check_submit_status();

            if (_this._$button.classList.contains('disabled')) {
                event.preventDefault();

                for (var j = 0, inputs_len = _this._$inputs.length; j < inputs_len; j++) {
                    _this._validate_input(this._$inputs[j]);
                }

                for (var i = 0, inputs_checkbox_len = _this._$inputs_checkbox.length; i < inputs_checkbox_len; i++) {
                    _this._validate_input_checkbox(this._$inputs_checkbox[i]);
                }

                for (var k = 0, inputs_checkbox_wrapper_len = _this._$inputs_checkbox_wrapper.length; k < inputs_checkbox_wrapper_len; k++) {
                    _this._validate_input_checkbox_wrapper(this._$inputs_checkbox_wrapper[k]);
                }

                for (var x = 0, selects_len = _this._$selects.length; x < selects_len; x++) {
                    _this._validate_select(this._$selects[x]);
                }

                _this._show_first_error();
            }
        }
    };

    var $forms = document.querySelectorAll('[data-form*="validate"]');

    for (var i = 0, len = $forms.length; i < len; i++) {
        new FormValidation($forms[i]).init();
    }
})(document, window);

// FORMULARE: EINGABE ZWISCHENSPEICHERN
// Wird verwendet für: formular
// -------------------------------------------------------------------------------------------------

(function(document) {
    var FormCache = function($form) {
        var _this = this;

        _this._$form     = $form;
        _this._form_name = _this._$form.getAttribute('data-form-cache');
        _this._$inputs   = _this._$form.querySelectorAll('input, select, textarea');
        _this._$cache    = {};
    };

    FormCache.prototype = {
        init: function() {
            var _this = this;

            _this._init_events();
            _this._restore_cache();
        },

        _init_events: function() {
            var _this = this,
                $input,
                type,
                event_listener;

            for (var i = 0, len = _this._$inputs.length; i < len; i++) {
                $input = _this._$inputs[i];
                type    = $input.type;

                if (type === 'checkbox') {
                    event_listener = 'click';
                }
                else if (type === 'select-one') {
                    event_listener = 'change';
                }
                else {
                    event_listener = 'input';
                }

                $input.addEventListener(event_listener, _this._save_cache.bind(_this, $input), false);
            }

            _this._$form.addEventListener('submit', _this._reset_cache.bind(_this), false);
        },

        _save_cache: function($input) {
            var _this = this,
                name  = $input.getAttribute('name'),
                type  = $input.type;

            if (type === 'checkbox') {
                _this._$cache[name] = $input.checked;
            }
            else if (type === 'select-one') {
                _this._$cache[name] = $input.selectedIndex;
            }
            else {
                _this._$cache[name] = $input.value;
            }

            localStorage.setItem(domain + '_form_cache_' + _this._form_name, JSON.stringify(_this._$cache));
        },

        _restore_cache: function() {
            var _this  = this,
                $cache = localStorage.getItem(domain + '_form_cache_' + _this._form_name),
                $input,
                type;

            if (!$cache) {
                return;
            }

            _this._$cache = JSON.parse($cache);

            for (var key in _this._$cache) {
                if (_this._$cache.hasOwnProperty(key)) {
                    $input = _this._$form.querySelector('[name="' + key + '"]');
                    type   = $input.type;

                    if (type === 'checkbox') {
                        $input.checked = _this._$cache[key];
                    }
                    else if (type === 'select-one') {
                        $input.selectedIndex = _this._$cache[key];
                    }
                    else {
                        $input.value = _this._$cache[key];
                    }
                }
            }
        },

        _reset_cache: function() {
            var _this    = this,
                is_valid = true;

            for (var i = 0, len = _this._$inputs.length; i < len; i++) {
                if (_this._$inputs[i].getAttribute('aria-invalid') === 'true') {
                    is_valid = false;
                    break;
                }
            }

            if (is_valid) {
                localStorage.removeItem(domain + '_form_cache_' + _this._form_name);
            }
        }
    };

    var $forms = document.querySelectorAll('[data-form-cache]');

    for (var i = 0, len = $forms.length; i < len; i++) {
        new FormCache($forms[i]).init();
    }
})(document);

// FORMULARE: TEXTAREA AUTOGROW
// Wird gebraucht für alle <textarea>
// -------------------------------------------------------------------------------------------------

(function(document) {
    function _camel_case_property(property) {
        return property.replace(/-([\da-z])/gi, function(all, letter) {
            return letter.toUpperCase();
        });
    }

    function _get_style($element, property) {
        var $styles = window.getComputedStyle($element, null),
            style   = $styles.getPropertyValue(property);

        return style;
    }

    function _set_style($element, $styles) {
        for (var property in $styles) {
            if ($styles.hasOwnProperty(property)) {
                $element.style[_camel_case_property(property)] = $styles[property];
            }
        }
    }

    var FormTextareaAutogrow = function($textarea) {
        var _this = this;

        _this.$textarea      = $textarea;
        _this.default_height = $textarea.offsetHeight;
        _this.line_height    = parseInt(_get_style($textarea, 'line-height'));
        _this.padding_bottom = parseInt(_get_style($textarea, 'padding-bottom'));
        _this.padding_top    = parseInt(_get_style($textarea, 'padding-top'));
    };

    FormTextareaAutogrow.prototype = {
        init: function() {
            var _this = this;

            _this.$textarea.addEventListener('blur', _this._set_textarea_height.bind(_this));
            _this.$textarea.addEventListener('focus', _this._set_textarea_height.bind(_this));
            _this.$textarea.addEventListener('keyup', _this._set_textarea_height.bind(_this));

            _this._set_textarea_height();
        },

        _set_textarea_height: function() {
            var _this = this,
                $lines = _this.$textarea.value.split('\n'),
                length = $lines.length,
                height = (length + 2) * _this.line_height + _this.padding_bottom + _this.padding_top;

            _set_style(_this.$textarea, {
                'height' : height >= _this.default_height ? height / 16 + 'rem' : _this.default_height / 16 + 'rem'
            });
        }
    };

    var $textareas = document.getElementsByTagName('textarea');

    for (var i = 0, $textarea; $textarea = $textareas[i]; i++) {
        new FormTextareaAutogrow($textarea).init();
    }
})(document);

// FORMULARE: STANDORT AUSWAHL
// Wird verwendet für: formular
// -------------------------------------------------------------------------------------------------

(function(document) {
    var $secure_targets = document.querySelectorAll('[name="secure_target"]');

    if (!$secure_targets.length) {
        return;
    }

    function selectLocation(id) {
        if (id) {
            var $locations_data = document.querySelectorAll('[data-forms-location=' + id + '] span');

            for (var j = 0, $location_data; $location_data = $locations_data[j]; j++) {
                var title  = $location_data.getAttribute('title'),
                    $input = document.querySelector('input[name="to_' + title + '"]');

                $input.value = $location_data.textContent.trim();
            }
        }
    }

    for (var i = 0, $secure_target; $secure_target = $secure_targets[i]; i++) {
        $secure_target.addEventListener('change', function() {
            selectLocation(this.options[this.selectedIndex].getAttribute('id'));
        });

        if ($secure_target.options && $secure_target.selectedIndex) {
            // Setzt die Werte aus dem Cache ins die Formular Post Variablen
            selectLocation($secure_target.options[$secure_target.selectedIndex].getAttribute('id'));
        }
    }
})(document);

// FORMULARE: ÜBERNIMMT URL-PARAMETER FÜR DIE INPUTS
// Wird gebraucht für: formular
// -------------------------------------------------------------------------------------------------

(function(document, window) {
    var FormUrlParameters = function($form) {
        var _this = this;

        _this._$form = $form;
    };

    FormUrlParameters.prototype = {
        init: function() {
            var _this = this,
                href  = window.location.href;

            if (href.indexOf('?') > -1) {
                _this._get_url_parameters(href);
            }
        },

        _get_url_parameters: function(href) {
            var _this       = this,
                $parameters = href.split('?')[1].split('&');

            _this._set_inputs_value($parameters);
        },

        _set_inputs_value: function($parameters) {
            var _this = this,
                $inputs,
                $pair,
                key,
                value,
                tagname,
                type;

            for (var i = 0, $parameter; $parameter = $parameters[i]; i++) {
                $pair   = $parameter.split('=');
                key     = $pair[0];
                value   = decodeURIComponent($pair[1].replace(/\+/g,' '));
                $inputs = _this._$form.querySelectorAll('[name=' + key + ']');

                if (!value || !$inputs.length) {
                    continue;
                }

                tagname = $inputs[0].tagName;

                if (tagname === 'SELECT') {
                    _this.selected_select($inputs[0], value);
                }
                else if (tagname === 'INPUT' || tagname === 'TEXTAREA') {
                    type = $inputs[0].type;

                    if (type === 'radio') {
                        _this._checked_input_radio($inputs, value);
                    }
                    else if (type === 'checkbox') {
                        $inputs[0].defaultChecked = value;
                    }
                    else {
                        $inputs[0].defaultValue = value;
                    }
                }
            }
        },

        selected_select: function($select, value) {
            var $options = $select.querySelectorAll('option');

            for (var j = 0, $option; $option = $options[j]; j++) {
                if ($option.getAttribute('value') === value) {
                    $option.defaultSelected = true;
                }
                else {
                    $option.defaultSelected = false;
                }
            }
        },

        _checked_input_radio: function($inputs, value) {
            for (var j = 0, $input; $input = $inputs[j]; j++) {
                if ($input.getAttribute('value') === value) {
                    $input.defaultChecked = true;
                }
                else {
                    $input.defaultChecked = false;
                }
            }
        }
    };

    var $forms = document.querySelectorAll('[data-form*="url-parameters"]');

    for (var i = 0, $form; $form = $forms[i]; i++) {
        new FormUrlParameters($form).init();
    }
})(document, window);

// FORMULARE: SUCHBEGRIFF-VORSCHLÄGE FÜR DIE SUCHE
// Wird gebraucht in: steuernews_search, search
// -------------------------------------------------------------------------------------------------

(function(document) {
    var FormSearchDataList = function($form) {
        var _this = this;

        _this.$form    = $form;
        _this.$search  = $form.querySelector('input[type="search"]');
        _this.$submit  = $form.querySelector('button[type="submit"]');
        _this.datalist = $form.getAttribute('data-datalist');
        _this.list     = _this.$search.getAttribute('list');

        _this.datalist_loaded   = false;
        _this.datalist_inserted = false;
    };

    FormSearchDataList.prototype = {
        init: function() {
            var _this = this;

            _this.$form.addEventListener('submit', _this._submit.bind(this));
            _this.$search.addEventListener('focus', _this._focus.bind(this));

            _this._init_keyboard();
            _this._get_datalist();
        },

        _init_keyboard: function() {
            var _this = this,
                $key  = {
                    'enter' : 13
                };

            _this.$search.addEventListener('keyup', function(event) {
                if (event.keyCode !== $key.enter) {
                    return;
                }

                var url = _this._get_url();

                if (url) {
                    location.href = url;
                }
            });
        },

        _get_datalist: function() {
            var _this     = this,
                $datalist = sessionStorage.getItem(domain + '_datalist_search'),
                $ajax,
                $options;

            if (!_this.datalist) {
                return;
            }

            if ($datalist) {
                $options = _this._get_sorted_datalist($datalist);
                _this._create_datalist($options);
            }
            else {
                $ajax = new XMLHttpRequest();
                $ajax.open('GET', _this.datalist, true);

                $ajax.onload = function() {
                    if (this.status === 200) {
                        sessionStorage.setItem(domain + '_datalist_search', this.responseText);

                        $options = _this._get_sorted_datalist(this.responseText);
                        _this._create_datalist($options);
                    }
                };

                $ajax.send();
            }
        },

        _get_sorted_datalist: function($datalist) {
            var $options = JSON.parse($datalist);

            $options = $options.sort(function($a, $b) {
                var a_value = $a.value.toLowerCase(),
                    b_value = $b.value.toLowerCase();

                if (a_value < b_value) {
                    return -1;
                }

                if (b_value < a_value) {
                    return 1;
                }
            });

            return $options;
        },

        _create_datalist: function($options) {
            var _this     = this,
                $datalist = document.createDocumentFragment(),
                $datalist_entry;

            for (var i = 0, $option; $option = $options[i]; i++) {
                $datalist_entry = document.createElement('option');

                if ($option.url) {
                    $datalist_entry.setAttribute('data-url', $option.url);
                }

                if ($option.label && /Chrome\b/.test(navigator.userAgent)) {
                    if (!(/Edge\b/.test(navigator.userAgent))) {
                        $datalist_entry.setAttribute('label', $option.label);
                    }
                }

                $datalist_entry.setAttribute('data-value', $option.value.toLowerCase());
                $datalist_entry.textContent = $option.value;
                $datalist.appendChild($datalist_entry);
            }

            _this.$datalist = $datalist;
        },

        _focus: function() {
            var _this = this;

            if (_this.$datalist && !_this.datalist_inserted) {
                document.querySelector('#' + _this.list).appendChild(_this.$datalist);
                _this.datalist_inserted = true;
                _this.$submit.removeAttribute('disabled');
            }
        },

        _get_url: function() {
            var _this   = this,
                value   = _this.$search.value.toLowerCase(),
                $option = document.querySelector('#' + _this.list + ' option[data-value="' + value + '"]');

            return $option ? $option.getAttribute('data-url') : '';
        },

        _submit: function(event) {
            var _this = this,
                url   = _this._get_url();

            if (url) {
                event.preventDefault();

                location.href = url;
            }
        }
    };

    var $forms = document.querySelectorAll('[data-form*="datalist"]');

    for (var i = 0, $form; $form = $forms[i]; i++) {
        new FormSearchDataList($form).init();
    }
})(document);

// SUCHE
// Wird gebraucht in: steuernews_search, suche
// -------------------------------------------------------------------------------------------------

(function(document) {
    var FormSearch = function($search) {
        var _this = this;

        _this.$search       = $search;
        _this.$input_search = $search.querySelector('input[type="search"]');
        _this.$button       = $search.querySelector('button[type="submit"]');
    };

    FormSearch.prototype = {
        init: function() {
            var _this = this;

            _this.$button.setAttribute('disabled', 'disabled');
            _this.$input_search.addEventListener('input', _this._on_input.bind(_this));
        },

        _on_input: function() {
            var _this = this;

            if (_this.$input_search.value.length > 0) {
                _this.$button.removeAttribute('disabled');
            }
            else {
                _this.$button.setAttribute('disabled', 'disabled');
            }
        }
    };

    var $search = document.querySelectorAll('[role="search"]');

    if ($search.length) {
        for (var i = 0, len = $search.length; i < len; i++) {
            new FormSearch($search[i]).init();
        }
    }
})(document);

// SUCHE (BOX)
// -------------------------------------------------------------------------------------------------

(function(document) {
    var FormSearchBox = function($toggle_search_box) {
        var _this = this,
            controls;

        _this.$toggle_search_box  = $toggle_search_box.querySelector('label');
        _this.$open_search_box    = $toggle_search_box.querySelector('.open_search_box');
        _this.$close_search_box_1 = $toggle_search_box.querySelector('.close_search_box');
        _this.$search_box_state   = document.querySelector('#' + _this.$toggle_search_box.getAttribute('for'));

        controls = _this.$open_search_box.getAttribute('aria-controls');

        _this.$search_box         = document.getElementById(controls);
        _this.$input_search       = _this.$search_box.querySelector('input[type="search"]');
        _this.$search_button      = _this.$search_box.querySelector('button[type="submit"]');
        _this.$close_search_box_2 = _this.$search_box.querySelector('.close_search_box');
        _this.$focus_elements     = _this.$search_box.querySelectorAll('input[type="search"], button[type="submit"], .close_search_box');

        _this.$key = {
            'escape' : 27,
            'space'  : 32,
            'tab'    : 9
        };
    };

    FormSearchBox.prototype = {
        init: function() {
            var _this = this;

            _this.$toggle_search_box.addEventListener('click', _this._toggle.bind(_this));
            _this.$open_search_box.addEventListener('click', _this._open.bind(_this));
            _this.$close_search_box_1.addEventListener('click', _this._close.bind(_this));
            _this.$close_search_box_2.addEventListener('click', _this._close.bind(_this));

            _this.$search_box.addEventListener('transitionend', function(event) {
                if (event.target !== this) {
                    return;
                }

                if (_this.$search_box_state.checked) {
                    _this.$input_search.focus();
                }
            });

            _this._init_keyboard();
        },

        _init_keyboard: function() {
            var _this = this;

            _this.$open_search_box.addEventListener('keydown', function(event) {
                if (event.keyCode === _this.$key.space) {
                    event.preventDefault();
                }
            });

            _this.$close_search_box_1.addEventListener('keydown', function(event) {
                if (event.keyCode === _this.$key.space) {
                    event.preventDefault();
                }
            });

            _this.$close_search_box_2.addEventListener('keydown', function(event) {
                if (event.keyCode === _this.$key.space) {
                    event.preventDefault();
                }
            });

            document.addEventListener('keydown', function(event) {
                if (!_this.$search_box_state.checked) {
                    return;
                }

                switch(event.keyCode) {
                    case _this.$key.escape:
                        _this._close(event);

                        break;

                    case _this.$key.tab:
                        event.preventDefault();

                        if (event.shiftKey) {
                            _this._focus_element_with_shift_tab_key(event);
                        }
                        else {
                            _this._focus_element_with_tab_key(event);
                        }

                        break;
                }
            });
        },

        _focus_element_with_shift_tab_key: function() {
            var _this = this;

            _this.tab_index -= 1;

            if (_this.$search_button === _this.$focus_elements[_this.tab_index] &&
                _this.$search_button.getAttribute('disabled') === 'disabled') {
                _this.tab_index -= 1;
            }
            if (_this.tab_index < 0) {
                _this.tab_index = _this.$focus_elements.length - 1;
            }

            _this.$focus_elements[_this.tab_index].focus();
        },

        _focus_element_with_tab_key: function() {
            var _this = this;

            if (_this.tab_index === _this.$focus_elements.length - 1) {
                _this.tab_index = 0;
            }
            else {
                _this.tab_index += 1;
            }

            if (_this.$search_button === _this.$focus_elements[_this.tab_index] &&
                _this.$search_button.getAttribute('disabled') === 'disabled') {
                _this.tab_index += 1;
            }

            _this.$focus_elements[_this.tab_index].focus();
        },

        _toggle: function(event) {
            var _this = this;

            if (_this.$search_box_state.checked) {
                _this._close(event);
            }
            else {
                _this._open(event);
            }
        },

        _open: function(event) {
            var _this = this;

            event.preventDefault();

            _this.$search_box_state.checked = true;
            _this.tab_index = 0;
        },

        _close: function(event) {
            var _this = this;

            event.preventDefault();

            _this.$search_box_state.checked = false;
            _this.$open_search_box.focus();
            _this.tab_index = 0;

            if (event.type === 'click') {
                _this.$open_search_box.setAttribute('data-focus-method', 'mouse');
            }
        }
    };

    var $toggle_search_box = document.getElementsByClassName('toggle_search_box');

    for (var i = 0, len = $toggle_search_box.length; i < len; i++) {
        new FormSearchBox($toggle_search_box[i]).init();
    }
})(document);

// STEUERNEWS SEO - ALLE AUSGABEN
// -------------------------------------------------------------------------------------------------

(function(document) {
    var SteuernewsIssues = function(issues_select) {
        var _this = this;

        _this.$issues_select    = issues_select;
        _this.$select           = issues_select.querySelector('select');
        _this.$button           = issues_select.querySelector('.button');
        _this.$active_option    = _this.$select.querySelector('option:checked');
    };

    SteuernewsIssues.prototype = {
        init: function() {
            var _this = this;

            _this.$select.addEventListener('change', function() {
                this.querySelectorAll('option')[this.selectedIndex];
                href = this.querySelectorAll('option')[this.selectedIndex].value;
                _this.$button.href = href;
            });
        },
    };

    var $steuernews_issues_select = document.querySelectorAll('.steuernews_issues_select');

    for (var i = 0; i < $steuernews_issues_select.length; i++) {
        new SteuernewsIssues($steuernews_issues_select[i]).init();
    }

})(document);

// ANIMATION HELPERS
// Wird standardmaeßig in keinem Template gebraucht.
// -------------------------------------------------------------------------------------------------

(function(document, window) {
    var AnimationHelpers = function($animated_element) {
        var _this = this;

        _this._$animated_element = $animated_element;
        _this._offset            = _this._$animated_element.getAttribute('data-animation-offset');
    };

    AnimationHelpers.prototype = {
        init: function() {
            var _this = this;

            _this.$show_animation = this._is_in_viewport.bind(_this);

            window.addEventListener('load', _this.$show_animation, true);
            window.addEventListener('scroll', _this.$show_animation, true);
        },

        _offset_top: function() {
            var _this  = this,
                $node = _this._$animated_element,
                top   = $node.offsetTop;

            while ($node = $node.offsetParent) {
                top += $node.offsetTop;
            }

            return top;
        },

        _is_in_viewport: function() {
            var _this      = this,
                scroll_top = window.pageYOffset + document.documentElement.clientHeight,
                offset_top = _this._offset_top();

            if (_this._offset) {
                offset_top = offset_top - _this._offset;
            }

            if (scroll_top >= offset_top) {
                _this._$animated_element.classList.add('animated');
                _this._remove_scroll_event();
            }
        },

        _remove_scroll_event: function() {
            var _this = this;

            window.removeEventListener('scroll', _this.$show_animation, true);
        }
    };

    var $animated_elements = document.querySelectorAll('[data-animated]');

    for (var i = 0, len = $animated_elements.length; i < len; i++) {
        new AnimationHelpers($animated_elements[i]).init();
    }
}(document, window));

// SCROLL DOWN HEADER
// Vergibt eine Klasse scrolled_down auf den Header
// -------------------------------------------------------------------------------------------------

(function(document, window) {
    var scrolled_down = function($animated_element) {
        var _this = this;
        _this._$animated_element = $animated_element;
    };

    scrolled_down.prototype = {
        init: function() {
            var _this = this;

            window.addEventListener('scroll', this._is_scrolled_down.bind(_this), true);

            _this._is_scrolled_down();
        },

        _is_scrolled_down: function() {
            var _this  = this;

            if (window.pageYOffset > 40) {
                _this._$animated_element.classList.add('scrolled_down');
            } else {
                _this._$animated_element.classList.remove('scrolled_down');
            }
        }

    };

    var $animated_elements = document.querySelectorAll('header[role="banner"] .top');

    for (var i = 0, len = $animated_elements.length; i < len; i++) {
        new scrolled_down($animated_elements[i]).init();
    }

}(document, window));

// INFOLISTEN: WEITERE WERTE
// Wird verwendet für Wichtige Beträge (show_more_content)
// -------------------------------------------------------------------------------------------------

(function(window) {
    var $share_button = document.querySelectorAll('.share_button');

    for (var i = 0, len = $share_button.length; i < len; i++) {
        $share_button[i].addEventListener('click', function(event) {
            event.preventDefault();

            var _this = this,
                href = _this.getAttribute('href');

            window.open(href,'Inhalt teilen','height=450, width=550, top=' + (window.innerHeight / 2 - 275) + ', left=' + (window.innerWidth / 2 - 225) + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
        });
    }
}(window));

// VCARD SWITCHER FÜR DESKTOP/MOBIL
// Wird verwendet für: team_overview, team_entry, address_vcard_button, steuernews_contact_person
// -------------------------------------------------------------------------------------------------

(function(document) {
    if (device.mobile || device.tablet) {
        return;
    }

    var $vcards = document.querySelectorAll('[data-vcard-href]');

    for (var i = 0, len = $vcards.length; i < len; i++) {
        var $vcard = $vcards[i],
            href   = $vcard.getAttribute('data-vcard-href');

        if (href) {
            $vcard.setAttribute('href', href);
            $vcard.removeAttribute('data-vcard-href');
        }
    }
}(document));

// Slideshow Animation
(function(document) {
    var BackgroundImageSlider = function($slider) {
        var _this       = this;
        _this.$slider   = $slider;
        _this.$slides   = _this.$slider.querySelectorAll('.background_image_wrapper'),
        _this.$dots     = _this.$slider.querySelectorAll('.pagination .item'),
        _this.$prev     = _this.$slider.querySelector('.navigation_wrapper .prev'),
        _this.$next     = _this.$slider.querySelector('.navigation_wrapper .next'),
        _this.index     = 0,
        _this.oldindex  = 0,
        _this.time      = 5000,
        _this.intervall,
        _this.touch_start_x;
    };

    BackgroundImageSlider.prototype = {
        init: function() {
            var _this = this;

            if (_this.$slides.length > 1) {
                _this._init_mouse();
                _this._init_touch();
                _this.intervall = setInterval(_this._callIntervall.bind(this), _this.time);
            }

            if (_this.$slides.length > 2) {
                document.querySelector('body').classList.add('has_pagination');
            }
        },

        _init_mouse: function() {
            var _this = this;

            for (var i = 0; i < _this.$dots.length; i++) {
                _this.$dots[i].index = i;
                _this.$dots[i].addEventListener('click', function(event) {
                    event.preventDefault();
                    _this._changeSlider(this.index);
                }, false);
            }
            if (_this.$prev) {
                _this.$prev.addEventListener('click', function(event) {
                    event.preventDefault();
                    _this._changeSlider(_this.index - 1);
                }, false);
            }
            if (_this.$next) {
                _this.$next.addEventListener('click', function(event) {
                    event.preventDefault();
                    _this._changeSlider(_this.index + 1);
                }, false);
            }
        },

        _changeSlider: function(newIndex) {
            clearInterval(this.intervall);
            this.intervall = setInterval(this._callIntervall.bind(this), this.time);

            if (newIndex === this.index) {
                return;
            }

            if (newIndex < 0) {
                newIndex = this.$slides.length - 1;
            }
            if (newIndex > this.$slides.length - 1) {
                newIndex = 0;
            }

            this.oldindex = this.index;
            this.index = newIndex;
            this.$slides[this.index].classList.add('show');
            this.$slides[this.oldindex].classList.remove('show');

            if (this.$dots && this.$dots.length > 0) {
                this.$dots[this.index].classList.add('active');
                this.$dots[this.oldindex].classList.remove('active');
            }
        },

        _init_touch: function() {
            var _this = this
            _this.$slider.addEventListener('touchstart', function(event) {
                _this.touch_start_x = event.changedTouches[0].pageX;
            });

            _this.$slider.addEventListener('touchmove', function(event) {
                var touch   = event.touches[0] || event.changedTouches[0],
                    touch_x = touch.pageX;

                if ((touch_x - _this.touch_start_x > 50) || (touch_x - _this.touch_start_x < -50)) {
                    event.preventDefault();
                }
            });

            _this.$slider.addEventListener('touchend', function(event) {
                var touch   = event.touches[0] || event.changedTouches[0],
                    touch_x = touch.pageX;

                if (touch_x - _this.touch_start_x > 50) {
                    _this._changeSlider(_this.index - 1);
                }
                else if (touch_x - _this.touch_start_x < -50) {
                    _this._changeSlider(_this.index + 1);
                }
            });
        },

        _callIntervall: function() {
            this._changeSlider(this.index + 1);
        },

    };

    var $slider = document.querySelectorAll('.background_image_slider_overview');

    for (var i = 0; i < $slider.length; i++) {
        new BackgroundImageSlider($slider[i]).init();
    }

})(document);

// SLIDER HORIZONTAL
// Wird verwendet für: steuernews_article_slider
// -------------------------------------------------------------------------------------------------

(function(document) {
    var Slider = function($slider) {
        var _this = this;

        _this.$slider_wrapper       = $slider;
        _this.$slider               = $slider.querySelector('.slider');
        _this.$news_entries         = $slider.querySelectorAll('.news_entry');
        _this.$prev_arrow_button    = $slider.querySelector('.prev_slide');
        _this.$next_arrow_button    = $slider.querySelector('.next_slide');
        _this.$slide_prev           = $slider.querySelector('.slide_prev');
        _this.$slide_active         = $slider.querySelector('.slide_active');
        _this.$slide_next           = $slider.querySelector('.slide_next');
        _this.$slide_in_out         = $slider.querySelector('.slide_in_out');
        _this.$news_entries_wrapper = $slider.querySelector('.news_entries_wrapper');

        _this.$next_slide_bind     = this._next_slide.bind(_this);
        _this.$prev_slide_bind     = this._prev_slide.bind(_this);

        _this.index                 = 0;
        _this.time                  = 4000;
        _this.intervall;
        _this.touch_start_x;

        // Stoppen wenn Maus über Objekt ist
        _this.stop_on_hover     = true;
    };

    Slider.prototype = {
        init: function() {
            var _this = this;

            _this.$slide_prev.innerHTML     = _this.$news_entries[_this.$news_entries.length - 1].innerHTML;
            _this.$slide_active.innerHTML   = _this.$news_entries[0].innerHTML;
            _this.$slide_next.innerHTML     = _this.$news_entries[1].innerHTML;
            _this.$slide_in_out.innerHTML   = _this.$news_entries[_this.$news_entries.length - 1].innerHTML;

            _this._init_mouse();
            _this._init_touch();

            if (_this.stop_on_hover) {
                _this.$slider.addEventListener('mouseover', function() {
                    clearInterval(_this.intervall);
                });

                _this.$slider.addEventListener('mouseout', function() {
                    clearInterval(_this.intervall);
                    _this.intervall = setInterval(_this.$next_slide_bind, _this.time);
                });
            }

            // Im Skript vergeben, wenn kein javascript aktiviert ist soll Button ausgeblendet sein
            _this.intervall = setInterval(_this.$next_slide_bind, _this.time);

            window.addEventListener('resize', function() {
                _this._set_height();
            });

            window.addEventListener('load', function() {
                _this._set_height();
            });

        },

        _init_mouse: function() {
            var _this = this;

            _this.$prev_arrow_button.addEventListener('click', function(event) {
                event.preventDefault();
                event.stopPropagation();
                _this._prev_slide();
            });

            _this.$next_arrow_button.addEventListener('click', function(event) {
                event.preventDefault();
                event.stopPropagation();
                _this._next_slide();
            });

            _this.$slide_next.addEventListener('click', _this.$next_slide_bind, false);
            _this.$slide_prev.addEventListener('click', _this.$prev_slide_bind, false);
        },

        _init_touch: function() {
            var _this = this

            _this.$slider.addEventListener('touchstart', function(event) {
                clearInterval(_this.intervall);
                _this.touch_start_x = event.changedTouches[0].pageX;
            });

            _this.$slider.addEventListener('touchend', function(event) {
                var touch   = event.touches[0] || event.changedTouches[0],
                    touch_x = touch.pageX;

                if (touch_x - _this.touch_start_x > 50) {
                    _this._prev_slide();
                    return;
                }
                else if (touch_x - _this.touch_start_x < -50) {
                    _this._next_slide();
                    return;
                }
                _this.intervall = setInterval(_this.$next_slide_bind, _this.time);
            });
        },

        _prev_slide: function() {
            var _this = this;

            _this.$slide_prev.removeEventListener('click', _this.$prev_slide_bind, false);
            _this.$slide_next.removeEventListener('click', _this.$next_slide_bind, false);

            clearInterval(_this.intervall);

            _this.index--;

            if (_this.index < 0) {
                _this.index = _this.$news_entries.length - 1;
            }

            // Fixes IE 11 Bug
            _this.$slide_prev.querySelector('.inner_description').classList.add('show');
            _this.$slide_active.querySelector('.inner_description').classList.add('hideme');
            var animate = setInterval(function() {

                _this.$slide_active.classList.remove('slide_active');
                _this.$slide_active.classList.add('slide_next');
                _this.$slide_next.classList.remove('slide_next');
                _this.$slide_next.classList.add('slide_in_out');
                _this.$slide_prev.classList.remove('slide_prev');
                _this.$slide_prev.classList.add('slide_active');

                if (_this.index === 0) {
                    _this.$slide_in_out.innerHTML = _this.$news_entries[_this.$news_entries.length - 1].innerHTML;
                } else {
                    _this.$slide_in_out.innerHTML = _this.$news_entries[_this.index - 1].innerHTML;
                }

                _this.$slide_in_out.classList.remove('slide_in_out');
                _this.$slide_in_out.classList.add('slide_prev');

                var temp = _this.$slide_next;

                _this.$slide_next = _this.$slide_active;
                _this.$slide_active = _this.$slide_prev;
                _this.$slide_prev = _this.$slide_in_out;
                _this.$slide_in_out = temp;

                _this.$slide_prev.addEventListener('click', _this.$prev_slide_bind, false);
                _this.$slide_next.addEventListener('click', _this.$next_slide_bind, false);

                _this.intervall = setInterval(_this.$next_slide_bind, _this.time);
                _this.$slide_prev.querySelector('.inner_description').classList.remove('show');
                _this.$slide_active.querySelector('.inner_description').classList.remove('hideme');
                clearInterval(animate);
            }, 10);
        },

        _next_slide: function() {
            var _this = this;

            clearInterval(_this.intervall);

            _this.$slide_prev.removeEventListener('click', _this.$prev_slide_bind, false);
            _this.$slide_next.removeEventListener('click', _this.$next_slide_bind, false);

            _this.index++;
            if (_this.index >= _this.$news_entries.length) {
                _this.index = 0;
            }

            // Fixes IE 11 Bug
            _this.$slide_next.querySelector('.inner_description').classList.add('show');
            _this.$slide_active.querySelector('.inner_description').classList.add('hideme');
            var animate = setInterval(function() {
                _this.$slide_prev.classList.remove('slide_prev');
                _this.$slide_prev.classList.add('slide_in_out');
                _this.$slide_active.classList.remove('slide_active');
                _this.$slide_active.classList.add('slide_prev');
                _this.$slide_next.classList.remove('slide_next');
                _this.$slide_next.classList.add('slide_active');

                if (_this.index + 1 >= _this.$news_entries.length) {
                    _this.$slide_in_out.innerHTML = _this.$news_entries[0].innerHTML;
                } else {
                    _this.$slide_in_out.innerHTML = _this.$news_entries[_this.index + 1].innerHTML;
                }

                _this.$slide_in_out.classList.remove('slide_in_out');
                _this.$slide_in_out.classList.add('slide_next');

                var temp = _this.$slide_prev;
                _this.$slide_prev = _this.$slide_active;
                _this.$slide_active = _this.$slide_next;
                _this.$slide_next = _this.$slide_in_out;

                _this.$slide_in_out = temp;

                _this.$slide_prev.addEventListener('click', _this.$prev_slide_bind, false);
                _this.$slide_next.addEventListener('click', _this.$next_slide_bind, false);

                _this.intervall = setInterval(_this.$next_slide_bind, _this.time);
                _this.$slide_next.querySelector('.inner_description').classList.remove('show');
                _this.$slide_active.querySelector('.inner_description').classList.remove('hideme');
                clearInterval(animate);
            }, 50);
        },

        _set_height: function() {
            var _this   = this,
                highest = 0,
                height = 0;

            // reset height
            _this.$slider_wrapper.style.height = 'auto';
            _this.$slider.style.height = 'auto';
            _this.$news_entries_wrapper.classList.remove('hideme');

            for (var i = 0; i < _this.$news_entries.length; i++) {
                height = _this.$news_entries[i].clientHeight;

                if (height > highest) {
                    highest = height;
                }
            }

            _this.$news_entries_wrapper.classList.add('hideme');

            height = height + 10;

            _this.$slider_wrapper.style.height = highest + 'px';
            _this.$slider.style.height = highest + 'px';
        }
    };

    var $sliders = document.querySelectorAll('.steuernews_article_slider');

    for (var i = 0, len = $sliders.length; i < len; i++) {
        new Slider($sliders[i]).init();
    }

})(document);

// YOUTUBE NACHTRÄGLICH LADEN
// -------------------------------------------------------------------------------------------------

(function(document) {
    var YoutubePlayer = function($movies) {
        this.$movies   = $movies;
    };

    YoutubePlayer.prototype = {
        init: function() {
            if (sessionStorage.getItem('show_youtube')) {
                this._show_all_movies();
            } else {
                this._setup_ui();
            }
        },

        _setup_ui: function() {
            var _this = this;

            for (var i = 0; i < this.$movies.length; i++) {
                this.$movies[i].querySelector('.button').addEventListener('click', function(event) {
                    event.preventDefault();
                    sessionStorage.setItem('show_youtube', true);
                    _this._show_all_movies();
                });
            }
        },

        _show_all_movies: function() {
            for (var i = 0; i < this.$movies.length; i++) {
                var $iframe     = this.$movies[i].querySelector('iframe'),
                    $overlay    = this.$movies[i].querySelector('.youtube_wrapper');

                $iframe.setAttribute('src', $iframe.getAttribute('data-src'));
                $iframe.removeAttribute('data-src');
                $overlay.classList.remove('show_message');
            }
        }
    };

    var $youtube_player = document.querySelectorAll('.youtube_player');

    if ($youtube_player.length > 0) {
        new YoutubePlayer($youtube_player).init();
    }

}(document));

// OPEN STREET MAPS
// -------------------------------------------------------------------------------------------------

(function(window) {
    var OpenStreetMap = function(id, locations, additional_markers, options) {
        this.id                         = id;
        this.locations                  = locations;
        this.additional_markers         = additional_markers;
        this.options                    = options;
        this.$map_id                    = document.querySelector('#open_street_map_' + this.id);
        this.$layer_additional_markers  = [];
        this.window_width               = window.innerWidth;
        this.$selected_location;
        this.$map;
    };

    OpenStreetMap.prototype = {
        init: function() {
            var _this = this;

            this._init_map();
            this._init_locations_markers();
            this._init_additional_markers();
            this._init_plan_route();

            window.addEventListener('resize', function() {

                // Manche mobilen Geräte lösen beim vertikalen Scrollen ein resize-Event aus, da die Browserleiste ein-/ausgeblendet wird

                if (_this.window_width !== window.innerWidth) {
                    _this.window_width = window.innerWidth;
                    _this._center_map();
                }
            });
        },

        // OpenStreetMap Karte initialisieren

        _init_map: function() {
            var _this = this;
            $view = new ol.View({
                center:         ol.proj.fromLonLat([this.options.center_lng, this.options.center_lat]),
                zoom:           this.options.zoom,
                minZoom:        this.options.min_zoom,
                maxZoom:        this.options.max_zoom,
                enableRotation: false
            });

            console.log();
            var url = '/maps/tile/{z}/{x}/{y}.png';

            // Anderer Tiles Server für die Verwendung auf der Beta
            if (window.location.hostname === 'beta.atikon.io') {
                url = 'https://maps.atikon.com/maps/tile/{z}/{x}/{y}.png';
            }

            var tile = new ol.layer.Tile({
                source: new ol.source.OSM({
                    url: url
                })
            });

            this.$map = new ol.Map({

                // Auf iOS-Geräten soll das Srollen in der Karte nur mit zwei Fingern möglich sein. iOS benötigt ein eigenes Handling. Nur im Konstruktor der Map funktioniert dieser Event-Listener in Kombination mit DragPan flüssig. Bei Chrome greift ein CSS Regel.

                interactions: ol.interaction.defaults({
                    dragPan:        false,  // Lösche die DragPan Standard Funktion
                    mouseWheelZoom: false   // Kein Zoomen beim Betätigen des Mausrads
                }).extend([new ol.interaction.DragPan({

                    // Fügt eine eigene abgeleitete Drag Funktion ein und erweitere die Standardfunktionen um diese

                    condition: function(event) {

                        // Wenn iOS: return regelt das Aktivieren der Drag-Funktion

                        if (document.querySelector('html').classList.contains('ios')) {

                            // Chrome hat momentan ein Pointer-Event und kein Touch-Event wie iOS

                            if (event.originalEvent.touches) {
                                var $map_overlay = _this.$map_id.querySelector('.map_overlay');

                                if (event.originalEvent.touches.length > 1) {
                                    $map_overlay.classList.remove('show');
                                } else {

                                    // Blende eine Bedienwarnung "zwei Finger zum Verschieben" ein

                                    $map_overlay.classList.add('show');
                                    setTimeout(function() {
                                        $map_overlay.classList.remove('show');
                                    }, 1000);
                                    return false;
                                }
                            }
                        }

                        return true;
                    }
                })]),
                target: 'map_' + this.id,
                layers: [tile],
                loadTilesWhileAnimating: true,
                view:   $view
            });

            // Soll Karte nach Graustufen konvertiert werden?

            if (this.options.grayscale) {
                tile.on('postcompose', function(event) {
                    var imageData = _this._convert_map_to_greyscale(event.context)
                    event.context.putImageData(imageData, 0, 0);
                });
            }

            this._setup_zoom_buttons();
        },

        // Zoom Buttons als inaktiv kennzeichnen

        _setup_zoom_buttons: function() {
            var _this = this,
                $zoom_in_button    = this.$map_id.querySelector('.ol-zoom-in'),
                $zoom_out_button   = this.$map_id.querySelector('.ol-zoom-out'),
                $view              = this.$map.getView();

            if ($view.getZoom() >= this.options.max_zoom) {
                $zoom_in_button.classList.add('disabled');
            }
            if ($view.getZoom() <= this.options.min_zoom) {
                $zoom_out_button.classList.add('disabled');
            }

            $view.on('change:resolution', function() {
                if ($view.getZoom() >= _this.options.max_zoom) {
                    $zoom_in_button.classList.add('disabled');
                } else {
                    $zoom_in_button.classList.remove('disabled');
                }

                if ($view.getZoom() <= _this.options.min_zoom) {
                    $zoom_out_button.classList.add('disabled');
                } else {
                    $zoom_out_button.classList.remove('disabled');
                }
            });
        },

        // Karte nach Graustufen konvertieren

        _convert_map_to_greyscale: function(context) {
            var imageData = context.getImageData(0, 0, context.canvas.width, context.canvas.height),
                data = imageData.data;

            for (i = 0; i < data.length; i = i + 4) {
                var red     = data[i],
                    green   = data[i + 1],
                    blue    = data[i + 2],
                    alpha   = data[i + 3];

                 var average = (red + green + blue) / 3;

                 // Beim Laden der Karte die Transparenz auf Null setzen

                 if (average === 0) {
                     alpha = 0;
                 } else {
                     alpha = 255;
                 }

                 data[i] = average;     // Rot
                 data[i + 1] = average; // Grün
                 data[i + 2] = average; // Blau
                 data[i + 3] = alpha;   // Alpha
            }

            return imageData;
        },

        // Marker für Standort positionieren

        _init_locations_markers: function() {
            for (var i = 0; i < this.locations.length; i++) {

                $marker = this._add_marker(
                    this.locations[i].lng,
                    this.locations[i].lat,
                    this.locations[i].marker
                );

                this.$map.addLayer($marker);
                $marker.setZIndex(10);
            }

            if (this.locations.length === 1) {
                this.$selected_location = this.locations[0];
            }

            this._center_map();
        },

        // Zusätzlich Marker positionieren

        _init_additional_markers: function() {
            for (var i = 0; i < this.additional_markers.length; i++) {
                $marker = this._add_marker(
                    this.additional_markers[i].lng,
                    this.additional_markers[i].lat,
                    this.additional_markers[i].marker
                );

                this.$layer_additional_markers.push($marker);
                this.$map.addLayer($marker);
                $marker.setZIndex(8);
                $marker.setVisible(false);
            }

            if (this.additional_markers.length > 0) {
                this._manage_additional_markers_visibility();
                var _this = this;

                this.$map.getView().on('propertychange', function(event) {
                    if (event.key === 'resolution') {
                        _this._manage_additional_markers_visibility();
                    }
                });
            }
        },

        // Zusätzlich Marker Sichtbarkeit anhand der Zoomstufe regulieren

        _manage_additional_markers_visibility: function() {
            for (var i = 0; i < this.additional_markers.length; i++) {
                if (this.$map.getView().getZoom() >= this.additional_markers[i].min_zoom_visible) {
                    this.$layer_additional_markers[i].setVisible(true);
                } else {
                    this.$layer_additional_markers[i].setVisible(false);
                }
            }
        },

        // Routenplanung initialisieren

        _init_plan_route: function() {
            var _this = this,
                $destination_select = this.$map_id.querySelector('select'),
                $plan_route_form    = this.$map_id.querySelector('form');

            if ($plan_route_form) {

                // Mehrere Standorte?

                if ($destination_select) {
                    $destination_select.addEventListener('change', function() {
                        if (this.options[this.selectedIndex].value !== '') {
                            _this.$selected_location = _this.locations[(this.options[this.selectedIndex].value)];
                            _this._update_plan_route_form($plan_route_form);
                        } else {

                            // Kein Standort ausgewählt
                            _this.$selected_location = '';
                            $plan_route_form.action = '';
                            _this._center_map();
                        }
                        _this._center_map();
                    });
                } else {
                    _this._update_plan_route_form($plan_route_form);
                }
            }
        },

        // Aktion für die Routenplanung via GoogleMaps zusammenbauen

        _update_plan_route_form: function($form) {
            var $daddr          = this.$map_id.querySelector('[name="daddr"]');

            $form.action = 'https://maps.google.de/maps';
            $daddr.value = this.$selected_location.postal_code + ' ' + this.$selected_location.locality + ', ' + this.$selected_location.street_address;
        },

        // Standardaktion für das Setzen von Markierungen (Standort und zusätzliche Markierungen)

        _add_marker: function(lng, lat, marker) {
            return new ol.layer.Vector({
                source: new ol.source.Vector({
                    features: [new ol.Feature({
                        geometry: new ol.geom.Point(
                            ol.proj.transform([lng, lat],
                            this.options.dataProjection,
                            this.options.featureProjection
                        )),
                    })]
                }),

                // Dient zur Ausrichtung der Markierung

                style: new ol.style.Style({
                    image: new ol.style.Icon({
                        anchor:         [0.5, 1],
                        anchorXUnits:   'fraction',
                        anchorYUnits:   'fraction',
                        src:            marker['href'],
                        scale:          0.5,
                        maxZoom:        1,
                    })
                })
            });
        },

        // Standardaktion zum Zentrieren der Karte

        _center_map: function() {

            // Ist eine Zentrierung der Karte gewünscht?

            if (this.options.center_lng === 0 && this.options.center_lat === 0) {

                // Gibt es nur einen Standort bzw. ist einer ausgewählt?

                if (this.locations.length === 1 || this.$selected_location) {
                    this._center_map_point(
                        this.$selected_location.lng,
                        this.$selected_location.lat,
                        this.options.zoom
                    );
                } else {
                    // mehrere Standorte anzeigen

                    this._center_map_more_locations();
                }
            } else {
                this._center_map_point(
                    this.options.center_lng,
                    this.options.center_lat,
                    this.options.center_zoom
                );
            }
        },

        // Karte auf einen Punkt zentrieren

        _center_map_point: function(lng, lat, zoom) {
            this.$map.getView().animate({
                center:     ol.proj.fromLonLat([lng, lat]),
                duration:   500,
                zoom:       zoom
            });
        },

        // Karte neu zentrieren anhand von mehreren Standorten mit einem Sicherheitsabstand

        _center_map_more_locations: function() {
            var extent = ol.proj.transformExtent(
                this._get_locations_bounds(),
                this.options.dataProjection,
                this.options.featureProjection
            );

            this.$map.getView().fit(extent, {
                size:                   this.$map.getSize(),
                padding:                this._max_marker_padding(),
                constrainResolution:    false,
                duration:               500
            });
        },

        // Minimale und maximale Grenzen der Standorte als Koordinaten-Array

        _get_locations_bounds: function() {
            var lng_min = this.locations[0].lng,
                lng_max = this.locations[0].lng,
                lat_min = this.locations[0].lat,
                lat_max = this.locations[0].lat;

            for (var i = 1; i < this.locations.length; i++) {
                if (this.locations[i].lng > lng_max) {
                    lng_max = this.locations[i].lng;
                }
                if (this.locations[i].lng < lng_min) {
                    lng_min = this.locations[i].lng;
                }
                if (this.locations[i].lat > lat_max) {
                    lat_max = this.locations[i].lat;
                }
                if (this.locations[i].lat < lat_min) {
                    lat_min = this.locations[i].lat;
                }
            }

            return [lng_min, lat_min, lng_max, lat_max];
        },

        // Sicherheitsabstand der Markierungen zum User-Interface und den Kartenrändern

        _max_marker_padding: function() {
            var max_height      = 0,
                max_width       = 0,
                default_padding = 30
                result          = [];

            for (var i = 0; i < this.locations.length; i++) {
                if (this.locations[i].marker.width > max_width) {
                    max_width = this.locations[i].marker.width;
                }
                if (this.locations[i].marker.height > max_height) {
                    max_height = this.locations[i].marker.height;
                }
            }

            result = [max_height + default_padding, max_width / 2 + default_padding + this.$map_id.querySelector('button').offsetWidth, default_padding, max_width / 2 + default_padding];

            return result;
        }
    };

    // Hole von jeder Karte die vorkommt die Daten und lege ein eigenes JavaScript-Objekt an

    if (window.$open_street_map_data) {
        for (var i = 0, len = window.$open_street_map_data.length; i < len; i++) {
            var id                  = window.$open_street_map_data[i].id,
                locations           = window.$open_street_map_data[i].locations,
                additional_markers  = window.$open_street_map_data[i].additional_markers,
                options             = window.$open_street_map_data[i].options;

            new OpenStreetMap(id, locations, additional_markers, options).init();
        }
    }

})(window);

// ACCORDION
// Wird verwendet für: infolist_list_content, listfoldercontent, u_online_benefits_1
// -------------------------------------------------------------------------------------------------

(function(document, window) {
    var Accordion = function($accordion) {
        var _this = this;

        _this.$accordion    = $accordion;
        _this.$tab          = $accordion.querySelectorAll('[role=tab]');
        _this.anchor        = location.hash;

        _this.one_tab_open  = true; // only one Tab open
    }
    Accordion.prototype = {
        init: function() {
            var _this  = this;

            _this._setup_accordion();
            _this._keyboard_nav();

            if (_this.anchor.length > 0) {
                var $accordion_entry = _this.$accordion.querySelector(_this.anchor);

                // no_anchor_link wird für Unternehmen Online verwendet

                if ($accordion_entry && !$accordion_entry.classList.contains('no_anchor_link')) {
                    _this._open_tabpanel($accordion_entry);
                }
            }

            for (var i = 0; i < _this.$tab.length; i++) {
                _this.$tab[i].addEventListener('click', function(event) {
                    var scroll = window.pageYOffset;
                    event.preventDefault();
                    _this._toggle_tabpanel(this);
                    window.scrollTo(0, scroll);
                });
            }

            window.addEventListener('resize', function() {
                _this._on_resize();
            });

        },

        _toggle_tabpanel: function($tab) {
            var _this = this;

            if ($tab.getAttribute('aria-expanded') === 'true') {
                _this._close_tabpanel($tab);
            }
            else {
                _this._open_tabpanel($tab);
            }
        },

        _close_tabpanel: function($tab) {
            var _this  = this,
                $tabpanel = _this._get_tabpanel($tab);

            $tab.setAttribute('aria-expanded', 'false');
            $tab.setAttribute('tabindex', '-1');
            $tabpanel.setAttribute('aria-hidden', 'true');
            $tabpanel.style.maxHeight = 0;
            $tabpanel.addEventListener('transitionend', function() {
                if (this.getAttribute('aria-hidden') === 'true') {
                    this.classList.add('hideme');
                }
            }, false);
        },

        _open_tabpanel: function($tab) {
            var _this  = this,
                $tabpanel = _this._get_tabpanel($tab);

            if (_this.one_tab_open) {
                for (var i = 0; i < _this.$tab.length; i++) {
                    if (_this.$tab[i] !== $tab) {
                        _this._close_tabpanel(_this.$tab[i]);
                    }
                }
            }

            $tab.setAttribute('aria-expanded', 'true');
            $tab.setAttribute('tabindex', '0');
            $tabpanel.setAttribute('aria-hidden', 'false');
            $tabpanel.classList.remove('hideme');
            window.location.hash = $tab.getAttribute('id');
            setTimeout(function() {
                $tabpanel.style.maxHeight = $tabpanel.max_height + 'px';
            }, 20);
        },

        _get_tabpanel: function($tab) {
            return document.querySelector('#' +  $tab.getAttribute('aria-controls'));
        },

        _setup_accordion: function() {
            var _this = this,
                $tabpanel;

            for (var i = 0; i < _this.$tab.length; i++) {
                _this.$tab[i].index = i;
                $tabpanel = _this._get_tabpanel(_this.$tab[i]);
                $tabpanel.classList.remove('hideme');
                $tabpanel.max_height = $tabpanel.clientHeight;
                _this._close_tabpanel(_this.$tab[i]);
                $tabpanel.classList.add('animated');
                $tabpanel.classList.add('hideme');
            }
            _this.$tab[0].setAttribute('tabindex', '0');
        },

        _on_resize: function() {
            var _this = this,
                $tabpanel;

            for (var i = 0; i < _this.$tab.length; i++) {
                $tabpanel = _this._get_tabpanel(_this.$tab[i]);
                $tabpanel.removeAttribute('style');
                $tabpanel.classList.remove('animated');
                $tabpanel.classList.remove('hideme');
                $tabpanel.max_height = $tabpanel.clientHeight;

                if (_this.$tab[i].getAttribute('aria-expanded') === 'true') {
                    _this._open_tabpanel(_this.$tab[i]);
                } else {
                    _this._close_tabpanel(_this.$tab[i]);
                }

                $tabpanel.classList.add('animated');
            }
        },

        _keyboard_nav: function() {
            var _this = this,
                $map  = {
                            13 : false, // Eingabe
                            32 : false, // Leertaste
                            35 : false, // Pos1
                            36 : false, // Ende
                            37 : false, // Pfeil nach links
                            38 : false, // Pfeil nach oben
                            39 : false, // Pfeil nach rechts
                            40 : false  // Pfeil nach unten
                        },
                index;

            for (var i = 0; i < _this.$tab.length; i++) {

                _this.$tab[i].addEventListener('keydown', function(event) {
                    index = this.index;
                    if (event.keyCode in $map) {
                        event.preventDefault();
                        $map[event.keyCode] = true;

                        if ($map[13] || $map[32]) {
                            _this._toggle_tabpanel(this);
                        }
                        else if ($map[35]) {
                            _this._change_focused_tab(_this.$tab.length - 1);
                        }
                        else if ($map[36]) {
                            _this._change_focused_tab(0);
                        }
                        else if ($map[37] || $map[38]) {
                            _this._change_focused_tab(index - 1);
                        }
                        else if ($map[39] || $map[40]) {
                            _this._change_focused_tab(index + 1);
                        }
                    }
                });

                _this.$tab[i].addEventListener('keyup', function(event) {
                    if (event.keyCode in $map) {
                        $map[event.keyCode] = false;
                    }
                });
            }
        },

        _change_focused_tab: function(index) {
            var _this = this;

            if (index === _this.$tab.length) {
                index = 0;
            }

            if (index === -1) {
                index = _this.$tab.length - 1;
            }

            $tab = _this.$tab[index];

            for (var i = 0; i < _this.$tab.length; i++) {
                _this.$tab[i].setAttribute('tabindex', '-1');
                _this.$tab[i].setAttribute('aria-selected', 'false');
            }

            $tab.setAttribute('tabindex', '0');
            $tab.setAttribute('aria-selected', 'true');

            $tab.focus();
        }
    };

    var $accordions = document.querySelectorAll('.accordion');

    for (var i = 0; i < $accordions.length; i++) {
        new Accordion($accordions[i]).init();
    }

})(document, window);

// ONLINETOOL POPUP
// Wird verwendet für: download_overview, onlinetools_popup_overview, video_tutorials_overview
// -------------------------------------------------------------------------------------------------

(function(document, window) {
    var OnlinetoolPopup = function($onlinetool) {
        var _this = this;

        _this.$onlinetool = $onlinetool;

        _this.title = $onlinetool.getAttribute('title');
        _this.id    = '#' + $onlinetool.getAttribute('data-popup-id');
        _this.href  = $onlinetool.getAttribute('href');
    },

    $body = document.querySelector('body'),
    $popup,
    $content,
    $close,
    $iframe;

    // Private

    function _create_element(html) {
        var $div            = document.createElement('div'),
            $filtered_nodes = [],
            $nodes;

        $div.innerHTML = html.trim();
        $nodes         = $div.childNodes;

        for (var i = 0, len = $nodes.length; $nodes !== null && i < len; i++) {
            if ($nodes[i].nodeType === 1) {
                $filtered_nodes.push($nodes[i]);
            }
        }

        return $filtered_nodes;
    }

    function _create_popup() {
        var html = '',
            $html;

        html += '<div class="hideme_print popup_overlay">';
        html += '<div class="popup_content">';
        html += '<div class="popup_header">';
        html += '<a class="popup_close" href=""><svg class="icon"><use xlink:href="' + zms_common + 'images/sprite/symbol/svg/sprite.symbol.svg#close"></use></svg></a>';
        html += '</div>';
        html += '<div class="content preloader">';
        html += '<svg class="icon_spin"><use xlink:href="' + zms_common + 'images/sprite/symbol/svg/sprite.symbol.svg#spin"></use></svg>';
        html += '<iframe class="popup_iframe" frameborder="0" src="" title="Onlinetool"></iframe>';
        html += '</div>';
        html += '</div>';
        html += '</div>';

        $html = _create_element(html);

        for (var j = 0, html_len = $html.length; j < html_len; j++) {
            $body.appendChild($html[j]);
        }

        $popup   = document.querySelector('.popup_overlay');
        $content = $popup.querySelector('.popup_content');
        $close   = $popup.querySelector('.popup_close');
        $iframe  = $popup.querySelector('iframe');

        $iframe.addEventListener('load', function() {
            if ($iframe.getAttribute('src').length && $popup.classList.contains('show')) {
                $iframe.classList.add('show');
            }
        });
    }

    function _close_popup() {
        var _close = function() {
            $body.classList.remove('no_scroll');
            $content.classList.remove('show');
            $iframe.classList.remove('show');

            window.history.replaceState(null, document.title, window.location.pathname);
        };

        $close.addEventListener('click', function(event) {
            event.preventDefault();
            _close();
        });

        document.addEventListener('keydown', function(event) {
            if ($popup.classList.contains('show') && event.which === 27) {
                _close();
            }
        });

        $content.addEventListener('transitionend', function() {
            if (!$content.classList.contains('show')) {
                $popup.classList.remove('show');
            }
        });
    }

    _create_popup();
    _close_popup();

    // Public

    OnlinetoolPopup.prototype = {
        init: function() {
            var _this = this;

            _this.$onlinetool.addEventListener('click', function(event) {
                event.preventDefault();
                _this.open();
            });
        },

        open: function() {
            var _this = this;

            $body.classList.add('no_scroll');
            $popup.classList.add('show');
            $content.classList.add('show');
            $iframe.setAttribute('src', _this.href);

            window.history.replaceState(null, document.title, _this.id);
        }
    };

    if (window.device.mobile || window.device.tablet) {
        return;
    }

    var $onlinetools = document.querySelectorAll('[data-popup="true"]'),
        $onlinetool;

    for (var i = 0, len = $onlinetools.length; i < len; i++) {
        $onlinetool = new OnlinetoolPopup($onlinetools[i]);

        $onlinetool.init();

        if ($onlinetool.id === window.location.hash) {
            $onlinetool.open();
        }
    }
})(document, window);

// SANFTES SCROLLEN
// -------------------------------------------------------------------------------------------------

(function(window) {

    var SmoothScroll = function() {
        this.offset_top                 = 40;   // Fixer Offsetwert
        this.offset_element             = '.top';   // Offset Element z.B.: 'header' oder '#main'
    }

    SmoothScroll.prototype = {
        init: function() {
            this._init_hyperlinks();
            this._init_selects();
            this._init_auto_scroll();
        },

        _init_hyperlinks: function() {
            var _this       = this,
                $hyperlinks = document.querySelectorAll('a[*|href*="#"]:not(.no_smooth_scroll)');

            for (var i = 0; i < $hyperlinks.length; i++) {
                $hyperlinks[i].addEventListener('click', function(event) {
                    var href    = this.getAttribute('href') || this.getAttribute('xlink:href'); // Benötigt wegen SVG Links

                    _this._manage_event_fired(href, event);
                });
            }
        },

        _init_selects: function() {
            var _this       = this;
                $selects    = document.querySelectorAll('select:not(.no_smooth_scroll)');

            for (var i = 0; i < $selects.length; i++) {
                $selects[i].addEventListener('change', function(event) {
                    var href    = this.options[this.selectedIndex].value;

                    _this._manage_event_fired(href, event);
                });
            }
        },

        _init_auto_scroll: function() {
            var _this   = this,
                hash    = location.hash
                $target = _this._get_target(hash);

            if ($target) {
                var parameter = location.search; // ?variable=1234 erhalten von URL Variablen

                location.hash = ''; // Scroll beginnt nicht am Seitenanfang bei erstmaligem Laden
                window.history.replaceState(null, document.title, location.pathname + parameter);

                var interval_firefox = setInterval(function() { // Firefox Bug - Scroll beginnt nicht am Seitenanfang
                    window.scrollTo(0, 0);
                    clearInterval(interval_firefox);
                }, 10);

                window.addEventListener('load', function() {
                    var interval = setInterval(function() { // Chrome, Edge: Timeout notwendig
                        clearInterval(interval);
                        _this._scroll_to($target);
                        window.history.replaceState(null, document.title, parameter + hash);
                    }, 10);
                });
            }
        },

        _manage_event_fired: function(href, event) {
            var $target = this._get_target(href);

            if ($target) {
                window.history.replaceState(null, document.title, this._get_url(href));
                event.preventDefault();
                this._scroll_to($target);
            }
        },

        _get_target: function(href) {
            var hash = href.split('#');

            if (hash.length > 1 && hash[1] !== '') {
                return document.querySelector('#' + hash[1] + ':not(.no_smooth_scroll)');
            }

            return null;
        },

        _get_url: function(href) {
            var hash        = '#' + href.split('#')[1],
                parameter   = href.split('#')[0]; // ?variable=1234 erhalten von URL Variablen

            if (parameter.length === 2) {
                parameter = '?' + parameter[1];
            }

            return parameter + hash;
        },

        _scroll_to: function($target) {
            var _this = this,
                top_position =  $target.offsetTop - this.offset_top - this._get_offset_element_height(),
                duration     = 300,
                interval;

            // Soll das Ziel fokusiert werden?
            if ($target.getAttribute('tabindex') !== '-1') {
                $target.focus(); // setzte den Fokus
            }

            interval = setInterval(function() {
                var diff = top_position - window.pageYOffset,
                    step = diff / duration * 10;

                if (Math.abs(diff) <= Math.abs(step)) {
                    clearInterval(interval);
                    _this._manage_highlighted($target);
                }

                window.scrollBy(0, step);
                duration -= 10;
            }, 10);
        },

        _get_offset_element_height: function() {
            if (this.offset_element) {
                return document.querySelector(this.offset_element).getBoundingClientRect().height;
            }

            return 0;
        },

        _manage_highlighted: function($target) {
            var $highlighted_target = $target;

            // Ist das Ziel keine Überschrift?
            if (!this._is_headline($target)) {
                // Ist das nächste darauf folgende Element eine Überschrift?
                if (this._is_headline($target.nextElementSibling)) {
                    $highlighted_target = $target.nextElementSibling;
                }
                else if (this._is_headline($target.querySelector('*'))) { // Ist das erste Unterelement eine Überschrift?
                    $highlighted_target = $target.querySelector('*');
                }
                else if (this._is_headline($target.parentElement)) { // Ist das Eltern Element eine Überschrift?
                    $highlighted_target = $target.parentElement;
                }
            }

            $highlighted_target.classList.add('highlighted');

            $highlighted_target.addEventListener('animationend', function() {
                $highlighted_target.classList.remove('highlighted');
            });
        },

        _is_headline: function(element) {
            if (element && element.tagName) {
                var result = element.tagName.match(/^h[1-9]$/i);

                if (result && result.length > 0) {
                    return true;
                }
            }

            return false;
        }
    };

    new SmoothScroll().init();

})(window);

/*! picturefill - v3.0.2 - 2016-02-12
 * https://scottjehl.github.io/picturefill/
 * Copyright (c) 2016 https://github.com/scottjehl/picturefill/blob/master/Authors.txt; Licensed MIT
 */
/*! Gecko-Picture - v1.0
 * https://github.com/scottjehl/picturefill/tree/3.0/src/plugins/gecko-picture
 * Firefox's early picture implementation (prior to FF41) is static and does
 * not react to viewport changes. This tiny module fixes this.
 */
(function(window) {
	/*jshint eqnull:true */
	var ua = navigator.userAgent;

	if ( window.HTMLPictureElement && ((/ecko/).test(ua) && ua.match(/rv\:(\d+)/) && RegExp.$1 < 45) ) {
		addEventListener("resize", (function() {
			var timer;

			var dummySrc = document.createElement("source");

			var fixRespimg = function(img) {
				var source, sizes;
				var picture = img.parentNode;

				if (picture.nodeName.toUpperCase() === "PICTURE") {
					source = dummySrc.cloneNode();

					picture.insertBefore(source, picture.firstElementChild);
					setTimeout(function() {
						picture.removeChild(source);
					});
				} else if (!img._pfLastSize || img.offsetWidth > img._pfLastSize) {
					img._pfLastSize = img.offsetWidth;
					sizes = img.sizes;
					img.sizes += ",100vw";
					setTimeout(function() {
						img.sizes = sizes;
					});
				}
			};

			var findPictureImgs = function() {
				var i;
				var imgs = document.querySelectorAll("picture > img, img[srcset][sizes]");
				for (i = 0; i < imgs.length; i++) {
					fixRespimg(imgs[i]);
				}
			};
			var onResize = function() {
				clearTimeout(timer);
				timer = setTimeout(findPictureImgs, 99);
			};
			var mq = window.matchMedia && matchMedia("(orientation: landscape)");
			var init = function() {
				onResize();

				if (mq && mq.addListener) {
					mq.addListener(onResize);
				}
			};

			dummySrc.srcset = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";

			if (/^[c|i]|d$/.test(document.readyState || "")) {
				init();
			} else {
				document.addEventListener("DOMContentLoaded", init);
			}

			return onResize;
		})());
	}
})(window);

/*! Picturefill - v3.0.2
 * http://scottjehl.github.io/picturefill
 * Copyright (c) 2015 https://github.com/scottjehl/picturefill/blob/master/Authors.txt;
 *  License: MIT
 */

(function( window, document, undefined ) {
	// Enable strict mode
	"use strict";

	// HTML shim|v it for old IE (IE9 will still need the HTML video tag workaround)
	document.createElement( "picture" );

	var warn, eminpx, alwaysCheckWDescriptor, evalId;
	// local object for method references and testing exposure
	var pf = {};
	var isSupportTestReady = false;
	var noop = function() {};
	var image = document.createElement( "img" );
	var getImgAttr = image.getAttribute;
	var setImgAttr = image.setAttribute;
	var removeImgAttr = image.removeAttribute;
	var docElem = document.documentElement;
	var types = {};
	var cfg = {
		//resource selection:
		algorithm: ""
	};
	var srcAttr = "data-pfsrc";
	var srcsetAttr = srcAttr + "set";
	// ua sniffing is done for undetectable img loading features,
	// to do some non crucial perf optimizations
	var ua = navigator.userAgent;
	var supportAbort = (/rident/).test(ua) || ((/ecko/).test(ua) && ua.match(/rv\:(\d+)/) && RegExp.$1 > 35 );
	var curSrcProp = "currentSrc";
	var regWDesc = /\s+\+?\d+(e\d+)?w/;
	var regSize = /(\([^)]+\))?\s*(.+)/;
	var setOptions = window.picturefillCFG;
	/**
	 * Shortcut property for https://w3c.github.io/webappsec/specs/mixedcontent/#restricts-mixed-content ( for easy overriding in tests )
	 */
	// baseStyle also used by getEmValue (i.e.: width: 1em is important)
	var baseStyle = "position:absolute;left:0;visibility:hidden;display:block;padding:0;border:none;font-size:1em;width:1em;overflow:hidden;clip:rect(0px, 0px, 0px, 0px)";
	var fsCss = "font-size:100%!important;";
	var isVwDirty = true;

	var cssCache = {};
	var sizeLengthCache = {};
	var DPR = window.devicePixelRatio;
	var units = {
		px: 1,
		"in": 96
	};
	var anchor = document.createElement( "a" );
	/**
	 * alreadyRun flag used for setOptions. is it true setOptions will reevaluate
	 * @type {boolean}
	 */
	var alreadyRun = false;

	// Reusable, non-"g" Regexes

	// (Don't use \s, to avoid matching non-breaking space.)
	var regexLeadingSpaces = /^[ \t\n\r\u000c]+/,
	    regexLeadingCommasOrSpaces = /^[, \t\n\r\u000c]+/,
	    regexLeadingNotSpaces = /^[^ \t\n\r\u000c]+/,
	    regexTrailingCommas = /[,]+$/,
	    regexNonNegativeInteger = /^\d+$/,

	    // ( Positive or negative or unsigned integers or decimals, without or without exponents.
	    // Must include at least one digit.
	    // According to spec tests any decimal point must be followed by a digit.
	    // No leading plus sign is allowed.)
	    // https://html.spec.whatwg.org/multipage/infrastructure.html#valid-floating-point-number
	    regexFloatingPoint = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/;

	var on = function(obj, evt, fn, capture) {
		if ( obj.addEventListener ) {
			obj.addEventListener(evt, fn, capture || false);
		} else if ( obj.attachEvent ) {
			obj.attachEvent( "on" + evt, fn);
		}
	};

	/**
	 * simple memoize function:
	 */

	var memoize = function(fn) {
		var cache = {};
		return function(input) {
			if ( !(input in cache) ) {
				cache[ input ] = fn(input);
			}
			return cache[ input ];
		};
	};

	// UTILITY FUNCTIONS

	// Manual is faster than RegEx
	// http://jsperf.com/whitespace-character/5
	function isSpace(c) {
		return (c === "\u0020" || // space
		        c === "\u0009" || // horizontal tab
		        c === "\u000A" || // new line
		        c === "\u000C" || // form feed
		        c === "\u000D");  // carriage return
	}

	/**
	 * gets a mediaquery and returns a boolean or gets a css length and returns a number
	 * @param css mediaqueries or css length
	 * @returns {boolean|number}
	 *
	 * based on: https://gist.github.com/jonathantneal/db4f77009b155f083738
	 */
	var evalCSS = (function() {

		var regLength = /^([\d\.]+)(em|vw|px)$/;
		var replace = function() {
			var args = arguments, index = 0, string = args[0];
			while (++index in args) {
				string = string.replace(args[index], args[++index]);
			}
			return string;
		};

		var buildStr = memoize(function(css) {

			return "return " + replace((css || "").toLowerCase(),
				// interpret `and`
				/\band\b/g, "&&",

				// interpret `,`
				/,/g, "||",

				// interpret `min-` as >=
				/min-([a-z-\s]+):/g, "e.$1>=",

				// interpret `max-` as <=
				/max-([a-z-\s]+):/g, "e.$1<=",

				//calc value
				/calc([^)]+)/g, "($1)",

				// interpret css values
				/(\d+[\.]*[\d]*)([a-z]+)/g, "($1 * e.$2)",
				//make eval less evil
				/^(?!(e.[a-z]|[0-9\.&=|><\+\-\*\(\)\/])).*/ig, ""
			) + ";";
		});

		return function(css, length) {
			var parsedLength;
			if (!(css in cssCache)) {
				cssCache[css] = false;
				if (length && (parsedLength = css.match( regLength ))) {
					cssCache[css] = parsedLength[ 1 ] * units[parsedLength[ 2 ]];
				} else {
					/*jshint evil:true */
					try{
						cssCache[css] = new Function("e", buildStr(css))(units);
					} catch(e) {}
					/*jshint evil:false */
				}
			}
			return cssCache[css];
		};
	})();

	var setResolution = function( candidate, sizesattr ) {
		if ( candidate.w ) { // h = means height: || descriptor.type === 'h' do not handle yet...
			candidate.cWidth = pf.calcListLength( sizesattr || "100vw" );
			candidate.res = candidate.w / candidate.cWidth ;
		} else {
			candidate.res = candidate.d;
		}
		return candidate;
	};

	/**
	 *
	 * @param opt
	 */
	var picturefill = function( opt ) {

		if (!isSupportTestReady) {return;}

		var elements, i, plen;

		var options = opt || {};

		if ( options.elements && options.elements.nodeType === 1 ) {
			if ( options.elements.nodeName.toUpperCase() === "IMG" ) {
				options.elements =  [ options.elements ];
			} else {
				options.context = options.elements;
				options.elements =  null;
			}
		}

		elements = options.elements || pf.qsa( (options.context || document), ( options.reevaluate || options.reselect ) ? pf.sel : pf.selShort );

		if ( (plen = elements.length) ) {

			pf.setupRun( options );
			alreadyRun = true;

			// Loop through all elements
			for ( i = 0; i < plen; i++ ) {
				pf.fillImg(elements[ i ], options);
			}

			pf.teardownRun( options );
		}
	};

	/**
	 * outputs a warning for the developer
	 * @param {message}
	 * @type {Function}
	 */
	warn = ( window.console && console.warn ) ?
		function( message ) {
			console.warn( message );
		} :
		noop
	;

	if ( !(curSrcProp in image) ) {
		curSrcProp = "src";
	}

	// Add support for standard mime types.
	types[ "image/jpeg" ] = true;
	types[ "image/gif" ] = true;
	types[ "image/png" ] = true;

	function detectTypeSupport( type, typeUri ) {
		// based on Modernizr's lossless img-webp test
		// note: asynchronous
		var image = new window.Image();
		image.onerror = function() {
			types[ type ] = false;
			picturefill();
		};
		image.onload = function() {
			types[ type ] = image.width === 1;
			picturefill();
		};
		image.src = typeUri;
		return "pending";
	}

	// test svg support
	types[ "image/svg+xml" ] = document.implementation.hasFeature( "http://www.w3.org/TR/SVG11/feature#Image", "1.1" );

	/**
	 * updates the internal vW property with the current viewport width in px
	 */
	function updateMetrics() {

		isVwDirty = false;
		DPR = window.devicePixelRatio;
		cssCache = {};
		sizeLengthCache = {};

		pf.DPR = DPR || 1;

		units.width = Math.max(window.innerWidth || 0, docElem.clientWidth);
		units.height = Math.max(window.innerHeight || 0, docElem.clientHeight);

		units.vw = units.width / 100;
		units.vh = units.height / 100;

		evalId = [ units.height, units.width, DPR ].join("-");

		units.em = pf.getEmValue();
		units.rem = units.em;
	}

	function chooseLowRes( lowerValue, higherValue, dprValue, isCached ) {
		var bonusFactor, tooMuch, bonus, meanDensity;

		//experimental
		if (cfg.algorithm === "saveData" ){
			if ( lowerValue > 2.7 ) {
				meanDensity = dprValue + 1;
			} else {
				tooMuch = higherValue - dprValue;
				bonusFactor = Math.pow(lowerValue - 0.6, 1.5);

				bonus = tooMuch * bonusFactor;

				if (isCached) {
					bonus += 0.1 * bonusFactor;
				}

				meanDensity = lowerValue + bonus;
			}
		} else {
			meanDensity = (dprValue > 1) ?
				Math.sqrt(lowerValue * higherValue) :
				lowerValue;
		}

		return meanDensity > dprValue;
	}

	function applyBestCandidate( img ) {
		var srcSetCandidates;
		var matchingSet = pf.getSet( img );
		var evaluated = false;
		if ( matchingSet !== "pending" ) {
			evaluated = evalId;
			if ( matchingSet ) {
				srcSetCandidates = pf.setRes( matchingSet );
				pf.applySetCandidate( srcSetCandidates, img );
			}
		}
		img[ pf.ns ].evaled = evaluated;
	}

	function ascendingSort( a, b ) {
		return a.res - b.res;
	}

	function setSrcToCur( img, src, set ) {
		var candidate;
		if ( !set && src ) {
			set = img[ pf.ns ].sets;
			set = set && set[set.length - 1];
		}

		candidate = getCandidateForSrc(src, set);

		if ( candidate ) {
			src = pf.makeUrl(src);
			img[ pf.ns ].curSrc = src;
			img[ pf.ns ].curCan = candidate;

			if ( !candidate.res ) {
				setResolution( candidate, candidate.set.sizes );
			}
		}
		return candidate;
	}

	function getCandidateForSrc( src, set ) {
		var i, candidate, candidates;
		if ( src && set ) {
			candidates = pf.parseSet( set );
			src = pf.makeUrl(src);
			for ( i = 0; i < candidates.length; i++ ) {
				if ( src === pf.makeUrl(candidates[ i ].url) ) {
					candidate = candidates[ i ];
					break;
				}
			}
		}
		return candidate;
	}

	function getAllSourceElements( picture, candidates ) {
		var i, len, source, srcset;

		// SPEC mismatch intended for size and perf:
		// actually only source elements preceding the img should be used
		// also note: don't use qsa here, because IE8 sometimes doesn't like source as the key part in a selector
		var sources = picture.getElementsByTagName( "source" );

		for ( i = 0, len = sources.length; i < len; i++ ) {
			source = sources[ i ];
			source[ pf.ns ] = true;
			srcset = source.getAttribute( "srcset" );

			// if source does not have a srcset attribute, skip
			if ( srcset ) {
				candidates.push( {
					srcset: srcset,
					media: source.getAttribute( "media" ),
					type: source.getAttribute( "type" ),
					sizes: source.getAttribute( "sizes" )
				} );
			}
		}
	}

	/**
	 * Srcset Parser
	 * By Alex Bell |  MIT License
	 *
	 * @returns Array [{url: _, d: _, w: _, h:_, set:_(????)}, ...]
	 *
	 * Based super duper closely on the reference algorithm at:
	 * https://html.spec.whatwg.org/multipage/embedded-content.html#parse-a-srcset-attribute
	 */

	// 1. Let input be the value passed to this algorithm.
	// (TO-DO : Explain what "set" argument is here. Maybe choose a more
	// descriptive & more searchable name.  Since passing the "set" in really has
	// nothing to do with parsing proper, I would prefer this assignment eventually
	// go in an external fn.)
	function parseSrcset(input, set) {

		function collectCharacters(regEx) {
			var chars,
			    match = regEx.exec(input.substring(pos));
			if (match) {
				chars = match[ 0 ];
				pos += chars.length;
				return chars;
			}
		}

		var inputLength = input.length,
		    url,
		    descriptors,
		    currentDescriptor,
		    state,
		    c,

		    // 2. Let position be a pointer into input, initially pointing at the start
		    //    of the string.
		    pos = 0,

		    // 3. Let candidates be an initially empty source set.
		    candidates = [];

		/**
		* Adds descriptor properties to a candidate, pushes to the candidates array
		* @return undefined
		*/
		// (Declared outside of the while loop so that it's only created once.
		// (This fn is defined before it is used, in order to pass JSHINT.
		// Unfortunately this breaks the sequencing of the spec comments. :/ )
		function parseDescriptors() {

			// 9. Descriptor parser: Let error be no.
			var pError = false,

			// 10. Let width be absent.
			// 11. Let density be absent.
			// 12. Let future-compat-h be absent. (We're implementing it now as h)
			    w, d, h, i,
			    candidate = {},
			    desc, lastChar, value, intVal, floatVal;

			// 13. For each descriptor in descriptors, run the appropriate set of steps
			// from the following list:
			for (i = 0 ; i < descriptors.length; i++) {
				desc = descriptors[ i ];

				lastChar = desc[ desc.length - 1 ];
				value = desc.substring(0, desc.length - 1);
				intVal = parseInt(value, 10);
				floatVal = parseFloat(value);

				// If the descriptor consists of a valid non-negative integer followed by
				// a U+0077 LATIN SMALL LETTER W character
				if (regexNonNegativeInteger.test(value) && (lastChar === "w")) {

					// If width and density are not both absent, then let error be yes.
					if (w || d) {pError = true;}

					// Apply the rules for parsing non-negative integers to the descriptor.
					// If the result is zero, let error be yes.
					// Otherwise, let width be the result.
					if (intVal === 0) {pError = true;} else {w = intVal;}

				// If the descriptor consists of a valid floating-point number followed by
				// a U+0078 LATIN SMALL LETTER X character
				} else if (regexFloatingPoint.test(value) && (lastChar === "x")) {

					// If width, density and future-compat-h are not all absent, then let error
					// be yes.
					if (w || d || h) {pError = true;}

					// Apply the rules for parsing floating-point number values to the descriptor.
					// If the result is less than zero, let error be yes. Otherwise, let density
					// be the result.
					if (floatVal < 0) {pError = true;} else {d = floatVal;}

				// If the descriptor consists of a valid non-negative integer followed by
				// a U+0068 LATIN SMALL LETTER H character
				} else if (regexNonNegativeInteger.test(value) && (lastChar === "h")) {

					// If height and density are not both absent, then let error be yes.
					if (h || d) {pError = true;}

					// Apply the rules for parsing non-negative integers to the descriptor.
					// If the result is zero, let error be yes. Otherwise, let future-compat-h
					// be the result.
					if (intVal === 0) {pError = true;} else {h = intVal;}

				// Anything else, Let error be yes.
				} else {pError = true;}
			} // (close step 13 for loop)

			// 15. If error is still no, then append a new image source to candidates whose
			// URL is url, associated with a width width if not absent and a pixel
			// density density if not absent. Otherwise, there is a parse error.
			if (!pError) {
				candidate.url = url;

				if (w) { candidate.w = w;}
				if (d) { candidate.d = d;}
				if (h) { candidate.h = h;}
				if (!h && !d && !w) {candidate.d = 1;}
				if (candidate.d === 1) {set.has1x = true;}
				candidate.set = set;

				candidates.push(candidate);
			}
		} // (close parseDescriptors fn)

		/**
		* Tokenizes descriptor properties prior to parsing
		* Returns undefined.
		* (Again, this fn is defined before it is used, in order to pass JSHINT.
		* Unfortunately this breaks the logical sequencing of the spec comments. :/ )
		*/
		function tokenize() {

			// 8.1. Descriptor tokeniser: Skip whitespace
			collectCharacters(regexLeadingSpaces);

			// 8.2. Let current descriptor be the empty string.
			currentDescriptor = "";

			// 8.3. Let state be in descriptor.
			state = "in descriptor";

			while (true) {

				// 8.4. Let c be the character at position.
				c = input.charAt(pos);

				//  Do the following depending on the value of state.
				//  For the purpose of this step, "EOF" is a special character representing
				//  that position is past the end of input.

				// In descriptor
				if (state === "in descriptor") {
					// Do the following, depending on the value of c:

				  // Space character
				  // If current descriptor is not empty, append current descriptor to
				  // descriptors and let current descriptor be the empty string.
				  // Set state to after descriptor.
					if (isSpace(c)) {
						if (currentDescriptor) {
							descriptors.push(currentDescriptor);
							currentDescriptor = "";
							state = "after descriptor";
						}

					// U+002C COMMA (,)
					// Advance position to the next character in input. If current descriptor
					// is not empty, append current descriptor to descriptors. Jump to the step
					// labeled descriptor parser.
					} else if (c === ",") {
						pos += 1;
						if (currentDescriptor) {
							descriptors.push(currentDescriptor);
						}
						parseDescriptors();
						return;

					// U+0028 LEFT PARENTHESIS (()
					// Append c to current descriptor. Set state to in parens.
					} else if (c === "\u0028") {
						currentDescriptor = currentDescriptor + c;
						state = "in parens";

					// EOF
					// If current descriptor is not empty, append current descriptor to
					// descriptors. Jump to the step labeled descriptor parser.
					} else if (c === "") {
						if (currentDescriptor) {
							descriptors.push(currentDescriptor);
						}
						parseDescriptors();
						return;

					// Anything else
					// Append c to current descriptor.
					} else {
						currentDescriptor = currentDescriptor + c;
					}
				// (end "in descriptor"

				// In parens
				} else if (state === "in parens") {

					// U+0029 RIGHT PARENTHESIS ())
					// Append c to current descriptor. Set state to in descriptor.
					if (c === ")") {
						currentDescriptor = currentDescriptor + c;
						state = "in descriptor";

					// EOF
					// Append current descriptor to descriptors. Jump to the step labeled
					// descriptor parser.
					} else if (c === "") {
						descriptors.push(currentDescriptor);
						parseDescriptors();
						return;

					// Anything else
					// Append c to current descriptor.
					} else {
						currentDescriptor = currentDescriptor + c;
					}

				// After descriptor
				} else if (state === "after descriptor") {

					// Do the following, depending on the value of c:
					// Space character: Stay in this state.
					if (isSpace(c)) {

					// EOF: Jump to the step labeled descriptor parser.
					} else if (c === "") {
						parseDescriptors();
						return;

					// Anything else
					// Set state to in descriptor. Set position to the previous character in input.
					} else {
						state = "in descriptor";
						pos -= 1;

					}
				}

				// Advance position to the next character in input.
				pos += 1;

			// Repeat this step.
			} // (close while true loop)
		}

		// 4. Splitting loop: Collect a sequence of characters that are space
		//    characters or U+002C COMMA characters. If any U+002C COMMA characters
		//    were collected, that is a parse error.
		while (true) {
			collectCharacters(regexLeadingCommasOrSpaces);

			// 5. If position is past the end of input, return candidates and abort these steps.
			if (pos >= inputLength) {
				return candidates; // (we're done, this is the sole return path)
			}

			// 6. Collect a sequence of characters that are not space characters,
			//    and let that be url.
			url = collectCharacters(regexLeadingNotSpaces);

			// 7. Let descriptors be a new empty list.
			descriptors = [];

			// 8. If url ends with a U+002C COMMA character (,), follow these substeps:
			//		(1). Remove all trailing U+002C COMMA characters from url. If this removed
			//         more than one character, that is a parse error.
			if (url.slice(-1) === ",") {
				url = url.replace(regexTrailingCommas, "");
				// (Jump ahead to step 9 to skip tokenization and just push the candidate).
				parseDescriptors();

			//	Otherwise, follow these substeps:
			} else {
				tokenize();
			} // (close else of step 8)

		// 16. Return to the step labeled splitting loop.
		} // (Close of big while loop.)
	}

	/*
	 * Sizes Parser
	 *
	 * By Alex Bell |  MIT License
	 *
	 * Non-strict but accurate and lightweight JS Parser for the string value <img sizes="here">
	 *
	 * Reference algorithm at:
	 * https://html.spec.whatwg.org/multipage/embedded-content.html#parse-a-sizes-attribute
	 *
	 * Most comments are copied in directly from the spec
	 * (except for comments in parens).
	 *
	 * Grammar is:
	 * <source-size-list> = <source-size># [ , <source-size-value> ]? | <source-size-value>
	 * <source-size> = <media-condition> <source-size-value>
	 * <source-size-value> = <length>
	 * http://www.w3.org/html/wg/drafts/html/master/embedded-content.html#attr-img-sizes
	 *
	 * E.g. "(max-width: 30em) 100vw, (max-width: 50em) 70vw, 100vw"
	 * or "(min-width: 30em), calc(30vw - 15px)" or just "30vw"
	 *
	 * Returns the first valid <css-length> with a media condition that evaluates to true,
	 * or "100vw" if all valid media conditions evaluate to false.
	 *
	 */

	function parseSizes(strValue) {

		// (Percentage CSS lengths are not allowed in this case, to avoid confusion:
		// https://html.spec.whatwg.org/multipage/embedded-content.html#valid-source-size-list
		// CSS allows a single optional plus or minus sign:
		// http://www.w3.org/TR/CSS2/syndata.html#numbers
		// CSS is ASCII case-insensitive:
		// http://www.w3.org/TR/CSS2/syndata.html#characters )
		// Spec allows exponential notation for <number> type:
		// http://dev.w3.org/csswg/css-values/#numbers
		var regexCssLengthWithUnits = /^(?:[+-]?[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?(?:ch|cm|em|ex|in|mm|pc|pt|px|rem|vh|vmin|vmax|vw)$/i;

		// (This is a quick and lenient test. Because of optional unlimited-depth internal
		// grouping parens and strict spacing rules, this could get very complicated.)
		var regexCssCalc = /^calc\((?:[0-9a-z \.\+\-\*\/\(\)]+)\)$/i;

		var i;
		var unparsedSizesList;
		var unparsedSizesListLength;
		var unparsedSize;
		var lastComponentValue;
		var size;

		// UTILITY FUNCTIONS

		//  (Toy CSS parser. The goals here are:
		//  1) expansive test coverage without the weight of a full CSS parser.
		//  2) Avoiding regex wherever convenient.
		//  Quick tests: http://jsfiddle.net/gtntL4gr/3/
		//  Returns an array of arrays.)
		function parseComponentValues(str) {
			var chrctr;
			var component = "";
			var componentArray = [];
			var listArray = [];
			var parenDepth = 0;
			var pos = 0;
			var inComment = false;

			function pushComponent() {
				if (component) {
					componentArray.push(component);
					component = "";
				}
			}

			function pushComponentArray() {
				if (componentArray[0]) {
					listArray.push(componentArray);
					componentArray = [];
				}
			}

			// (Loop forwards from the beginning of the string.)
			while (true) {
				chrctr = str.charAt(pos);

				if (chrctr === "") { // ( End of string reached.)
					pushComponent();
					pushComponentArray();
					return listArray;
				} else if (inComment) {
					if ((chrctr === "*") && (str[pos + 1] === "/")) { // (At end of a comment.)
						inComment = false;
						pos += 2;
						pushComponent();
						continue;
					} else {
						pos += 1; // (Skip all characters inside comments.)
						continue;
					}
				} else if (isSpace(chrctr)) {
					// (If previous character in loop was also a space, or if
					// at the beginning of the string, do not add space char to
					// component.)
					if ( (str.charAt(pos - 1) && isSpace( str.charAt(pos - 1) ) ) || !component ) {
						pos += 1;
						continue;
					} else if (parenDepth === 0) {
						pushComponent();
						pos +=1;
						continue;
					} else {
						// (Replace any space character with a plain space for legibility.)
						chrctr = " ";
					}
				} else if (chrctr === "(") {
					parenDepth += 1;
				} else if (chrctr === ")") {
					parenDepth -= 1;
				} else if (chrctr === ",") {
					pushComponent();
					pushComponentArray();
					pos += 1;
					continue;
				} else if ( (chrctr === "/") && (str.charAt(pos + 1) === "*") ) {
					inComment = true;
					pos += 2;
					continue;
				}

				component = component + chrctr;
				pos += 1;
			}
		}

		function isValidNonNegativeSourceSizeValue(s) {
			if (regexCssLengthWithUnits.test(s) && (parseFloat(s) >= 0)) {return true;}
			if (regexCssCalc.test(s)) {return true;}
			// ( http://www.w3.org/TR/CSS2/syndata.html#numbers says:
			// "-0 is equivalent to 0 and is not a negative number." which means that
			// unitless zero and unitless negative zero must be accepted as special cases.)
			if ((s === "0") || (s === "-0") || (s === "+0")) {return true;}
			return false;
		}

		// When asked to parse a sizes attribute from an element, parse a
		// comma-separated list of component values from the value of the element's
		// sizes attribute (or the empty string, if the attribute is absent), and let
		// unparsed sizes list be the result.
		// http://dev.w3.org/csswg/css-syntax/#parse-comma-separated-list-of-component-values

		unparsedSizesList = parseComponentValues(strValue);
		unparsedSizesListLength = unparsedSizesList.length;

		// For each unparsed size in unparsed sizes list:
		for (i = 0; i < unparsedSizesListLength; i++) {
			unparsedSize = unparsedSizesList[i];

			// 1. Remove all consecutive <whitespace-token>s from the end of unparsed size.
			// ( parseComponentValues() already omits spaces outside of parens. )

			// If unparsed size is now empty, that is a parse error; continue to the next
			// iteration of this algorithm.
			// ( parseComponentValues() won't push an empty array. )

			// 2. If the last component value in unparsed size is a valid non-negative
			// <source-size-value>, let size be its value and remove the component value
			// from unparsed size. Any CSS function other than the calc() function is
			// invalid. Otherwise, there is a parse error; continue to the next iteration
			// of this algorithm.
			// http://dev.w3.org/csswg/css-syntax/#parse-component-value
			lastComponentValue = unparsedSize[unparsedSize.length - 1];

			if (isValidNonNegativeSourceSizeValue(lastComponentValue)) {
				size = lastComponentValue;
				unparsedSize.pop();
			} else {
				continue;
			}

			// 3. Remove all consecutive <whitespace-token>s from the end of unparsed
			// size. If unparsed size is now empty, return size and exit this algorithm.
			// If this was not the last item in unparsed sizes list, that is a parse error.
			if (unparsedSize.length === 0) {
				return size;
			}

			// 4. Parse the remaining component values in unparsed size as a
			// <media-condition>. If it does not parse correctly, or it does parse
			// correctly but the <media-condition> evaluates to false, continue to the
			// next iteration of this algorithm.
			// (Parsing all possible compound media conditions in JS is heavy, complicated,
			// and the payoff is unclear. Is there ever an situation where the
			// media condition parses incorrectly but still somehow evaluates to true?
			// Can we just rely on the browser/polyfill to do it?)
			unparsedSize = unparsedSize.join(" ");
			if (!(pf.matchesMedia( unparsedSize ) ) ) {
				continue;
			}

			// 5. Return size and exit this algorithm.
			return size;
		}

		// If the above algorithm exhausts unparsed sizes list without returning a
		// size value, return 100vw.
		return "100vw";
	}

	// namespace
	pf.ns = ("pf" + new Date().getTime()).substr(0, 9);

	// srcset support test
	pf.supSrcset = "srcset" in image;
	pf.supSizes = "sizes" in image;
	pf.supPicture = !!window.HTMLPictureElement;

	// UC browser does claim to support srcset and picture, but not sizes,
	// this extended test reveals the browser does support nothing
	if (pf.supSrcset && pf.supPicture && !pf.supSizes) {
		(function(image2) {
			image.srcset = "data:,a";
			image2.src = "data:,a";
			pf.supSrcset = image.complete === image2.complete;
			pf.supPicture = pf.supSrcset && pf.supPicture;
		})(document.createElement("img"));
	}

	// Safari9 has basic support for sizes, but does't expose the `sizes` idl attribute
	if (pf.supSrcset && !pf.supSizes) {

		(function() {
			var width2 = "data:image/gif;base64,R0lGODlhAgABAPAAAP///wAAACH5BAAAAAAALAAAAAACAAEAAAICBAoAOw==";
			var width1 = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
			var img = document.createElement("img");
			var test = function() {
				var width = img.width;

				if (width === 2) {
					pf.supSizes = true;
				}

				alwaysCheckWDescriptor = pf.supSrcset && !pf.supSizes;

				isSupportTestReady = true;
				// force async
				setTimeout(picturefill);
			};

			img.onload = test;
			img.onerror = test;
			img.setAttribute("sizes", "9px");

			img.srcset = width1 + " 1w," + width2 + " 9w";
			img.src = width1;
		})();

	} else {
		isSupportTestReady = true;
	}

	// using pf.qsa instead of dom traversing does scale much better,
	// especially on sites mixing responsive and non-responsive images
	pf.selShort = "picture>img,img[srcset]";
	pf.sel = pf.selShort;
	pf.cfg = cfg;

	/**
	 * Shortcut property for `devicePixelRatio` ( for easy overriding in tests )
	 */
	pf.DPR = (DPR  || 1 );
	pf.u = units;

	// container of supported mime types that one might need to qualify before using
	pf.types =  types;

	pf.setSize = noop;

	/**
	 * Gets a string and returns the absolute URL
	 * @param src
	 * @returns {String} absolute URL
	 */

	pf.makeUrl = memoize(function(src) {
		anchor.href = src;
		return anchor.href;
	});

	/**
	 * Gets a DOM element or document and a selctor and returns the found matches
	 * Can be extended with jQuery/Sizzle for IE7 support
	 * @param context
	 * @param sel
	 * @returns {NodeList|Array}
	 */
	pf.qsa = function(context, sel) {
		return ( "querySelector" in context ) ? context.querySelectorAll(sel) : [];
	};

	/**
	 * Shortcut method for matchMedia ( for easy overriding in tests )
	 * wether native or pf.mMQ is used will be decided lazy on first call
	 * @returns {boolean}
	 */
	pf.matchesMedia = function() {
		if ( window.matchMedia && (matchMedia( "(min-width: 0.1em)" ) || {}).matches ) {
			pf.matchesMedia = function( media ) {
				return !media || ( matchMedia( media ).matches );
			};
		} else {
			pf.matchesMedia = pf.mMQ;
		}

		return pf.matchesMedia.apply( this, arguments );
	};

	/**
	 * A simplified matchMedia implementation for IE8 and IE9
	 * handles only min-width/max-width with px or em values
	 * @param media
	 * @returns {boolean}
	 */
	pf.mMQ = function( media ) {
		return media ? evalCSS(media) : true;
	};

	/**
	 * Returns the calculated length in css pixel from the given sourceSizeValue
	 * http://dev.w3.org/csswg/css-values-3/#length-value
	 * intended Spec mismatches:
	 * * Does not check for invalid use of CSS functions
	 * * Does handle a computed length of 0 the same as a negative and therefore invalid value
	 * @param sourceSizeValue
	 * @returns {Number}
	 */
	pf.calcLength = function( sourceSizeValue ) {

		var value = evalCSS(sourceSizeValue, true) || false;
		if (value < 0) {
			value = false;
		}

		return value;
	};

	/**
	 * Takes a type string and checks if its supported
	 */

	pf.supportsType = function( type ) {
		return ( type ) ? types[ type ] : true;
	};

	/**
	 * Parses a sourceSize into mediaCondition (media) and sourceSizeValue (length)
	 * @param sourceSizeStr
	 * @returns {*}
	 */
	pf.parseSize = memoize(function( sourceSizeStr ) {
		var match = ( sourceSizeStr || "" ).match(regSize);
		return {
			media: match && match[1],
			length: match && match[2]
		};
	});

	pf.parseSet = function( set ) {
		if ( !set.cands ) {
			set.cands = parseSrcset(set.srcset, set);
		}
		return set.cands;
	};

	/**
	 * returns 1em in css px for html/body default size
	 * function taken from respondjs
	 * @returns {*|number}
	 */
	pf.getEmValue = function() {
		var body;
		if ( !eminpx && (body = document.body) ) {
			var div = document.createElement( "div" ),
				originalHTMLCSS = docElem.style.cssText,
				originalBodyCSS = body.style.cssText;

			div.style.cssText = baseStyle;

			// 1em in a media query is the value of the default font size of the browser
			// reset docElem and body to ensure the correct value is returned
			docElem.style.cssText = fsCss;
			body.style.cssText = fsCss;

			body.appendChild( div );
			eminpx = div.offsetWidth;
			body.removeChild( div );

			//also update eminpx before returning
			eminpx = parseFloat( eminpx, 10 );

			// restore the original values
			docElem.style.cssText = originalHTMLCSS;
			body.style.cssText = originalBodyCSS;

		}
		return eminpx || 16;
	};

	/**
	 * Takes a string of sizes and returns the width in pixels as a number
	 */
	pf.calcListLength = function( sourceSizeListStr ) {
		// Split up source size list, ie ( max-width: 30em ) 100%, ( max-width: 50em ) 50%, 33%
		//
		//                           or (min-width:30em) calc(30% - 15px)
		if ( !(sourceSizeListStr in sizeLengthCache) || cfg.uT ) {
			var winningLength = pf.calcLength( parseSizes( sourceSizeListStr ) );

			sizeLengthCache[ sourceSizeListStr ] = !winningLength ? units.width : winningLength;
		}

		return sizeLengthCache[ sourceSizeListStr ];
	};

	/**
	 * Takes a candidate object with a srcset property in the form of url/
	 * ex. "images/pic-medium.png 1x, images/pic-medium-2x.png 2x" or
	 *     "images/pic-medium.png 400w, images/pic-medium-2x.png 800w" or
	 *     "images/pic-small.png"
	 * Get an array of image candidates in the form of
	 *      {url: "/foo/bar.png", resolution: 1}
	 * where resolution is http://dev.w3.org/csswg/css-values-3/#resolution-value
	 * If sizes is specified, res is calculated
	 */
	pf.setRes = function( set ) {
		var candidates;
		if ( set ) {

			candidates = pf.parseSet( set );

			for ( var i = 0, len = candidates.length; i < len; i++ ) {
				setResolution( candidates[ i ], set.sizes );
			}
		}
		return candidates;
	};

	pf.setRes.res = setResolution;

	pf.applySetCandidate = function( candidates, img ) {
		if ( !candidates.length ) {return;}
		var candidate,
			i,
			j,
			length,
			bestCandidate,
			curSrc,
			curCan,
			candidateSrc,
			abortCurSrc;

		var imageData = img[ pf.ns ];
		var dpr = pf.DPR;

		curSrc = imageData.curSrc || img[curSrcProp];

		curCan = imageData.curCan || setSrcToCur(img, curSrc, candidates[0].set);

		// if we have a current source, we might either become lazy or give this source some advantage
		if ( curCan && curCan.set === candidates[ 0 ].set ) {

			// if browser can abort image request and the image has a higher pixel density than needed
			// and this image isn't downloaded yet, we skip next part and try to save bandwidth
			abortCurSrc = (supportAbort && !img.complete && curCan.res - 0.1 > dpr);

			if ( !abortCurSrc ) {
				curCan.cached = true;

				// if current candidate is "best", "better" or "okay",
				// set it to bestCandidate
				if ( curCan.res >= dpr ) {
					bestCandidate = curCan;
				}
			}
		}

		if ( !bestCandidate ) {

			candidates.sort( ascendingSort );

			length = candidates.length;
			bestCandidate = candidates[ length - 1 ];

			for ( i = 0; i < length; i++ ) {
				candidate = candidates[ i ];
				if ( candidate.res >= dpr ) {
					j = i - 1;

					// we have found the perfect candidate,
					// but let's improve this a little bit with some assumptions ;-)
					if (candidates[ j ] &&
						(abortCurSrc || curSrc !== pf.makeUrl( candidate.url )) &&
						chooseLowRes(candidates[ j ].res, candidate.res, dpr, candidates[ j ].cached)) {

						bestCandidate = candidates[ j ];

					} else {
						bestCandidate = candidate;
					}
					break;
				}
			}
		}

		if ( bestCandidate ) {

			candidateSrc = pf.makeUrl( bestCandidate.url );

			imageData.curSrc = candidateSrc;
			imageData.curCan = bestCandidate;

			if ( candidateSrc !== curSrc ) {
				pf.setSrc( img, bestCandidate );
			}
			pf.setSize( img );
		}
	};

	pf.setSrc = function( img, bestCandidate ) {
		var origWidth;
		img.src = bestCandidate.url;

		// although this is a specific Safari issue, we don't want to take too much different code paths
		if ( bestCandidate.set.type === "image/svg+xml" ) {
			origWidth = img.style.width;
			img.style.width = (img.offsetWidth + 1) + "px";

			// next line only should trigger a repaint
			// if... is only done to trick dead code removal
			if ( img.offsetWidth + 1 ) {
				img.style.width = origWidth;
			}
		}
	};

	pf.getSet = function( img ) {
		var i, set, supportsType;
		var match = false;
		var sets = img [ pf.ns ].sets;

		for ( i = 0; i < sets.length && !match; i++ ) {
			set = sets[i];

			if ( !set.srcset || !pf.matchesMedia( set.media ) || !(supportsType = pf.supportsType( set.type )) ) {
				continue;
			}

			if ( supportsType === "pending" ) {
				set = supportsType;
			}

			match = set;
			break;
		}

		return match;
	};

	pf.parseSets = function( element, parent, options ) {
		var srcsetAttribute, imageSet, isWDescripor, srcsetParsed;

		var hasPicture = parent && parent.nodeName.toUpperCase() === "PICTURE";
		var imageData = element[ pf.ns ];

		if ( imageData.src === undefined || options.src ) {
			imageData.src = getImgAttr.call( element, "src" );
			if ( imageData.src ) {
				setImgAttr.call( element, srcAttr, imageData.src );
			} else {
				removeImgAttr.call( element, srcAttr );
			}
		}

		if ( imageData.srcset === undefined || options.srcset || !pf.supSrcset || element.srcset ) {
			srcsetAttribute = getImgAttr.call( element, "srcset" );
			imageData.srcset = srcsetAttribute;
			srcsetParsed = true;
		}

		imageData.sets = [];

		if ( hasPicture ) {
			imageData.pic = true;
			getAllSourceElements( parent, imageData.sets );
		}

		if ( imageData.srcset ) {
			imageSet = {
				srcset: imageData.srcset,
				sizes: getImgAttr.call( element, "sizes" )
			};

			imageData.sets.push( imageSet );

			isWDescripor = (alwaysCheckWDescriptor || imageData.src) && regWDesc.test(imageData.srcset || "");

			// add normal src as candidate, if source has no w descriptor
			if ( !isWDescripor && imageData.src && !getCandidateForSrc(imageData.src, imageSet) && !imageSet.has1x ) {
				imageSet.srcset += ", " + imageData.src;
				imageSet.cands.push({
					url: imageData.src,
					d: 1,
					set: imageSet
				});
			}

		} else if ( imageData.src ) {
			imageData.sets.push( {
				srcset: imageData.src,
				sizes: null
			} );
		}

		imageData.curCan = null;
		imageData.curSrc = undefined;

		// if img has picture or the srcset was removed or has a srcset and does not support srcset at all
		// or has a w descriptor (and does not support sizes) set support to false to evaluate
		imageData.supported = !( hasPicture || ( imageSet && !pf.supSrcset ) || (isWDescripor && !pf.supSizes) );

		if ( srcsetParsed && pf.supSrcset && !imageData.supported ) {
			if ( srcsetAttribute ) {
				setImgAttr.call( element, srcsetAttr, srcsetAttribute );
				element.srcset = "";
			} else {
				removeImgAttr.call( element, srcsetAttr );
			}
		}

		if (imageData.supported && !imageData.srcset && ((!imageData.src && element.src) ||  element.src !== pf.makeUrl(imageData.src))) {
			if (imageData.src === null) {
				element.removeAttribute("src");
			} else {
				element.src = imageData.src;
			}
		}

		imageData.parsed = true;
	};

	pf.fillImg = function(element, options) {
		var imageData;
		var extreme = options.reselect || options.reevaluate;

		// expando for caching data on the img
		if ( !element[ pf.ns ] ) {
			element[ pf.ns ] = {};
		}

		imageData = element[ pf.ns ];

		// if the element has already been evaluated, skip it
		// unless `options.reevaluate` is set to true ( this, for example,
		// is set to true when running `picturefill` on `resize` ).
		if ( !extreme && imageData.evaled === evalId ) {
			return;
		}

		if ( !imageData.parsed || options.reevaluate ) {
			pf.parseSets( element, element.parentNode, options );
		}

		if ( !imageData.supported ) {
			applyBestCandidate( element );
		} else {
			imageData.evaled = evalId;
		}
	};

	pf.setupRun = function() {
		if ( !alreadyRun || isVwDirty || (DPR !== window.devicePixelRatio) ) {
			updateMetrics();
		}
	};

	// If picture is supported, well, that's awesome.
	if ( pf.supPicture ) {
		picturefill = noop;
		pf.fillImg = noop;
	} else {

		 // Set up picture polyfill by polling the document
		(function() {
			var isDomReady;
			var regReady = window.attachEvent ? /d$|^c/ : /d$|^c|^i/;

			var run = function() {
				var readyState = document.readyState || "";

				timerId = setTimeout(run, readyState === "loading" ? 200 :  999);
				if ( document.body ) {
					pf.fillImgs();
					isDomReady = isDomReady || regReady.test(readyState);
					if ( isDomReady ) {
						clearTimeout( timerId );
					}

				}
			};

			var timerId = setTimeout(run, document.body ? 9 : 99);

			// Also attach picturefill on resize and readystatechange
			// http://modernjavascript.blogspot.com/2013/08/building-better-debounce.html
			var debounce = function(func, wait) {
				var timeout, timestamp;
				var later = function() {
					var last = (new Date()) - timestamp;

					if (last < wait) {
						timeout = setTimeout(later, wait - last);
					} else {
						timeout = null;
						func();
					}
				};

				return function() {
					timestamp = new Date();

					if (!timeout) {
						timeout = setTimeout(later, wait);
					}
				};
			};
			var lastClientWidth = docElem.clientHeight;
			var onResize = function() {
				isVwDirty = Math.max(window.innerWidth || 0, docElem.clientWidth) !== units.width || docElem.clientHeight !== lastClientWidth;
				lastClientWidth = docElem.clientHeight;
				if ( isVwDirty ) {
					pf.fillImgs();
				}
			};

			on( window, "resize", debounce(onResize, 99 ) );
			on( document, "readystatechange", run );
		})();
	}

	pf.picturefill = picturefill;
	//use this internally for easy monkey patching/performance testing
	pf.fillImgs = picturefill;
	pf.teardownRun = noop;

	/* expose methods for testing */
	picturefill._ = pf;

	window.picturefillCFG = {
		pf: pf,
		push: function(args) {
			var name = args.shift();
			if (typeof pf[name] === "function") {
				pf[name].apply(pf, args);
			} else {
				cfg[name] = args[0];
				if (alreadyRun) {
					pf.fillImgs( { reselect: true } );
				}
			}
		}
	};

	while (setOptions && setOptions.length) {
		window.picturefillCFG.push(setOptions.shift());
	}

	/* expose picturefill */
	window.picturefill = picturefill;

	/* expose picturefill */
	if ( typeof module === "object" && typeof module.exports === "object" ) {
		// CommonJS, just export
		module.exports = picturefill;
	} else if ( typeof define === "function" && define.amd ) {
		// AMD support
		define( "picturefill", function() { return picturefill; } );
	}

	// IE8 evals this sync, so it must be the last thing we do
	if ( !pf.supPicture ) {
		types[ "image/webp" ] = detectTypeSupport("image/webp", "data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAABBxAR/Q9ERP8DAABWUDggGAAAADABAJ0BKgEAAQADADQlpAADcAD++/1QAA==" );
	}

} )( window, document );

// Hintergrundbild nach links verlängern
(function(document) {
    var $bg_img_left            = document.querySelectorAll('.bg_image_left .background_image_content .background_image'),
        $bg_img_right           = document.querySelectorAll('.bg_image_right .background_image_content .background_image'),
        $bg_image_full_width    = document.querySelectorAll('.bg_image_full_width .background_image_content .background_image'),
        $page_wrapper 	         = document.querySelector('.page_wrapper');

    if ($bg_img_left.length < 1 && $bg_img_right.length < 1 && $bg_image_full_width.length < 1) {
        return;
    }

    function calc_background_image_left() {
        if (window.matchMedia('(min-width: 990px)').matches) {
            for (var i = 0; i < $bg_img_left.length; i++) {
                $bg_img_left[i].style.left = - $bg_img_left[i].getBoundingClientRect()['left'] + $page_wrapper.getBoundingClientRect()['left'] + 'px';
            }
            for (var i = 0; i < $bg_img_right.length; i++) {
                $bg_img_right[i].style.right = $bg_img_right[i].getBoundingClientRect()['right'] - $page_wrapper.getBoundingClientRect()['right'] + 'px';
            }
            for (var i = 0; i < $bg_image_full_width.length; i++) {
                $bg_image_full_width[i].style.left = - $bg_image_full_width[i].getBoundingClientRect()['left'] + $page_wrapper.getBoundingClientRect()['left'] + 'px';

                $bg_image_full_width[i].style.right = $bg_image_full_width[i].getBoundingClientRect()['right'] - $page_wrapper.getBoundingClientRect()['right'] + 'px';
            }
        } else {
            for (var i = 0; i < $bg_img_left.length; i++) {
                $bg_img_left[i].style.left = '50%';
            }
            for (var i = 0; i < $bg_img_right.length; i++) {
                $bg_img_right[i].style.right = 0 + 'px';
            }

            for (var i = 0; i < $bg_image_full_width.length; i++) {
                $bg_img_left[i].style.left = '50%';
                $bg_img_right[i].style.right = 0 + 'px';
            }
        }
    }

    window.addEventListener('resize', function(){
        for (var i = 0; i < $bg_img_left.length; i++) {
            $bg_img_left[i].style.left = 0 + 'px';
        }
        for (var i = 0; i < $bg_img_right.length; i++) {
            $bg_img_right[i].style.right = 0 + 'px';
        }
        for (var i = 0; i < $bg_image_full_width.length; i++) {
            $bg_image_full_width[i].style.left = 0 + 'px';
            $bg_image_full_width[i].style.right = 0 + 'px';
        }
        calc_background_image_left();
    }, false);

    calc_background_image_left();


}(document));

// Teambeschreibung Akkordion
(function(document) {
    var $team_entries   = document.querySelectorAll('.team_overview .entry'),
        $team_profiles  = document.querySelectorAll('.team_overview .entry .profile'),
        height          = 0;

    if ($team_profiles.length < 1 || $team_profiles.length < 1) {
        return;
    }

    function calc_heights() {
        for (var i = 0; i < $team_profiles.length; i++) {
            $team_profiles[i].style.height = 'auto';
            $team_entries[i].original_height = $team_profiles[i].getBoundingClientRect()['height'] + 20;
            $team_profiles[i].style.height = height + 'px';
            $team_entries[i].querySelector('.profile_read_more').classList.add('show');
            $team_entries[i].is_open = false;
        }
    }

    function setupt_events() {
        for (var i = 0; i < $team_entries.length; i++) {
            if (document.querySelector('html.touch')) {
                $team_entries[i].addEventListener('click', function() {
                    if (this.is_open) {
                        this.querySelector('.profile').style.height = height + 'px';
                        this.querySelector('.profile_read_more').classList.add('show');
                        this.is_open = false;
                    } else {
                        this.querySelector('.profile').style.height = this.original_height + 'px';
                        this.querySelector('.profile_read_more').classList.remove('show');
                        this.is_open = true;
                    }
                });
            } else {
                $team_entries[i].addEventListener('mouseover', function() {
                    this.querySelector('.profile').style.height = this.original_height + 'px';
                    this.querySelector('.profile_read_more').classList.remove('show');
                    this.is_open = true;
                });

                $team_entries[i].addEventListener('mouseout', function() {
                    this.querySelector('.profile').style.height = height + 'px';
                    this.querySelector('.profile_read_more').classList.add('show');
                    this.is_open = false;
                });
            }
        }

        window.addEventListener('resize', function(){
    		calc_heights();
        }, false);
    }

    calc_heights();
    setupt_events();

}(document));
